export const pucCodes = [
  { value: '1', label: '1 - ACTIVO' },
  { value: '11', label: '11 - DISPONIBLE' },
  { value: '1105', label: '1105 - CAJA' },
  { value: '110505', label: '110505 - CAJA GENERAL' },
  { value: '110510', label: '110510 - CAJAS MENORES' },
  { value: '110515', label: '110515 - MONEDA EXTRANJERA' },
  { value: '1110', label: '1110 - BANCOS' },
  { value: '111005', label: '111005 - MONEDA NACIONAL' },
  { value: '111010', label: '111010 - MONEDA EXTRANJERA' },
  { value: '1115', label: '1115 - REMESAS EN TRANSITO' },
  { value: '111505', label: '111505 - MONEDA NACIONAL' },
  { value: '111510', label: '111510 - MONEDA EXTRANJERA' },
  { value: '1120', label: '1120 - CUENTAS DE AHORRO' },
  { value: '112005', label: '112005 - BANCOS' },
  { value: '112010', label: '112010 - CORPORACIONES DE AHORRO Y VIVIENDA' },
  { value: '112015', label: '112015 - ORGANISMOS COOPERATIVOS FINANCIEROS' },
  { value: '1125', label: '1125 - FONDOS' },
  { value: '112505', label: '112505 - ROTATORIOS MONEDA NACIONAL' },
  { value: '112510', label: '112510 - ROTATORIOS MONEDA EXTRANJERA' },
  { value: '112515', label: '112515 - ESPECIALES MONEDA NACIONAL' },
  { value: '112520', label: '112520 - ESPECIALES MONEDA EXTRANJERA' },
  { value: '112525', label: '112525 - DE AMORTIZACION MONEDA NACIONAL' },
  { value: '112530', label: '112530 - DE AMORTIZACION MONEDA EXTRANJERA' },
  { value: '12', label: '12 - INVERSIONES' },
  { value: '1205', label: '1205 - ACCIONES' },
  { value: '120505', label: '120505 - AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: '120510', label: '120510 - PESCA' },
  { value: '120515', label: '120515 - EXPLOTACION DE MINAS Y CANTERAS' },
  { value: '120520', label: '120520 - INDUSTRIA MANUFACTURERA' },
  { value: '120525', label: '120525 - SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: '120530', label: '120530 - CONSTRUCCION' },
  { value: '120535', label: '120535 - COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: '120540', label: '120540 - HOTELES Y RESTAURANTES' },
  { value: '120545', label: '120545 - TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: '120550', label: '120550 - ACTIVIDAD FINANCIERA' },
  { value: '120555', label: '120555 - ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: '120560', label: '120560 - ENSEÑANZA' },
  { value: '120565', label: '120565 - SERVICIOS SOCIALES Y DE SALUD' },
  { value: '120570', label: '120570 - OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES' },
  { value: '120599', label: '120599 - AJUSTES POR INFLACION' },
  { value: '1210', label: '1210 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '121005', label: '121005 - AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: '121010', label: '121010 - PESCA' },
  { value: '121015', label: '121015 - EXPLOTACION DE MINAS Y CANTERAS' },
  { value: '121020', label: '121020 - INDUSTRIA MANUFACTURERA' },
  { value: '121025', label: '121025 - SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: '121030', label: '121030 - CONSTRUCCION' },
  { value: '121035', label: '121035 - COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: '121040', label: '121040 - HOTELES Y RESTAURANTES' },
  { value: '121045', label: '121045 - TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: '121050', label: '121050 - ACTIVIDAD FINANCIERA' },
  { value: '121055', label: '121055 - ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: '121060', label: '121060 - ENSEÑANZA' },
  { value: '121065', label: '121065 - SERVICIOS SOCIALES Y DE SALUD' },
  { value: '121070', label: '121070 - OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES Y PERSONALES' },
  { value: '121099', label: '121099 - AJUSTES POR INFLACION' },
  { value: '1215', label: '1215 - BONOS' },
  { value: '121505', label: '121505 - BONOS PUBLICOS MONEDA NACIONAL' },
  { value: '121510', label: '121510 - BONOS PUBLICOS MONEDA EXTRANJERA' },
  { value: '121515', label: '121515 - BONOS ORDINARIOS' },
  { value: '121520', label: '121520 - BONOS CONVERTIBLES EN ACCIONES' },
  { value: '121595', label: '121595 - OTROS' },
  { value: '1220', label: '1220 - CEDULAS' },
  { value: '122005', label: '122005 - CEDULAS DE CAPITALIZACION' },
  { value: '122010', label: '122010 - CEDULAS HIPOTECARIAS' },
  { value: '122015', label: '122015 - CEDULAS DE INVERSION' },
  { value: '122095', label: '122095 - OTRAS' },
  { value: '1225', label: '1225 - CERTIFICADOS' },
  { value: '122505', label: '122505 - CERTIFICADOS DE DEPOSITO A TERMINO (C.D.T.)' },
  { value: '122510', label: '122510 - CERTIFICADOS DE DEPOSITO DE AHORRO' },
  { value: '122515', label: '122515 - CERTIFICADOS DE AHORRO DE VALOR CONSTANTE (C.A.V.C.)' },
  { value: '122520', label: '122520 - CERTIFICADOS DE CAMBIO' },
  { value: '122525', label: '122525 - CERTIFICADOS CAFETEROS VALORIZABLES' },
  { value: '122530', label: '122530 - CERTIFICADOS ELECTRICOS VALORIZABLES (C.E.V.)' },
  { value: '122535', label: '122535 - CERTIFICADOS DE REEMBOLSO TRIBUTARIO (C.E.R.T.)' },
  { value: '122540', label: '122540 - CERTIFICADOS DE DESARROLLO TURISTICO' },
  { value: '122545', label: '122545 - CERTIFICADOS DE INVERSION FORESTAL (C.I.F.)' },
  { value: '122595', label: '122595 - OTROS' },
  { value: '1230', label: '1230 - PAPELES COMERCIALES' },
  { value: '123005', label: '123005 - EMPRESAS COMERCIALES' },
  { value: '123010', label: '123010 - EMPRESAS INDUSTRIALES' },
  { value: '123015', label: '123015 - EMPRESAS DE SERVICIOS' },
  { value: '1235', label: '1235 - TITULOS' },
  { value: '123505', label: '123505 - TITULOS DE DESARROLLO AGROPECUARIO' },
  { value: '123510', label: '123510 - TITULOS CANJEABLES POR CERTIFICADOS DE CAMBIO' },
  { value: '123515', label: '123515 - TITULOS DE TESORERIA (T.E.S.)' },
  { value: '123520', label: '123520 - TITULOS DE PARTICIPACION' },
  { value: '123525', label: '123525 - TITULOS DE CREDITO DE FOMENTO' },
  { value: '123530', label: '123530 - TITULOS FINANCIEROS AGROINDUSTRIALES (T.F.A.)' },
  { value: '123535', label: '123535 - TITULOS DE AHORRO CAFETERO (T.A.C.)' },
  { value: '123540', label: '123540 - TITULOS DE AHORRO NACIONAL (T.A.N.)' },
  { value: '123545', label: '123545 - TITULOS ENERGETICOS DE RENTABILIDAD CRECIENTE (T.E.R.)' },
  { value: '123550', label: '123550 - TITULOS DE AHORRO EDUCATIVO (T.A.E.)' },
  { value: '123555', label: '123555 - TITULOS FINANCIEROS  INDUSTRIALES Y COMERCIALES' },
  { value: '123560', label: '123560 - TESOROS' },
  { value: '123565', label: '123565 - TITULOS DE DEVOLUCION DE IMPUESTOS NACIONALES (TIDIS)' },
  { value: '123570', label: '123570 - TITULOS INMOBILIARIOS' },
  { value: '123595', label: '123595 - OTROS' },
  { value: '1240', label: '1240 - ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: '124005', label: '124005 - BANCOS COMERCIALES' },
  { value: '124010', label: '124010 - COMPAÑIAS DE FINANCIAMIENTO COMERCIAL' },
  { value: '124015', label: '124015 - CORPORACIONES FINANCIERAS' },
  { value: '124095', label: '124095 - OTRAS' },
  { value: '1245', label: '1245 - DERECHOS FIDUCIARIOS' },
  { value: '124505', label: '124505 - FIDEICOMISOS DE INVERSION MONEDA NACIONAL' },
  { value: '124510', label: '124510 - FIDEICOMISOS DE INVERSION MONEDA EXTRANJERA' },
  { value: '1250', label: '1250 - DERECHOS DE RECOMPRA DE INVERSIONES NEGOCIADAS (REPOS)' },
  { value: '125005', label: '125005 - ACCIONES' },
  { value: '125010', label: '125010 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '125015', label: '125015 - BONOS' },
  { value: '125020', label: '125020 - CEDULAS' },
  { value: '125025', label: '125025 - CERTIFICADOS' },
  { value: '125030', label: '125030 - PAPELES COMERCIALES' },
  { value: '125035', label: '125035 - TITULOS' },
  { value: '125040', label: '125040 - ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: '125095', label: '125095 - OTROS' },
  { value: '125099', label: '125099 - AJUSTES POR INFLACION' },
  { value: '1255', label: '1255 - OBLIGATORIAS' },
  { value: '125505', label: '125505 - BONOS DE FINANCIAMIENTO ESPECIAL' },
  { value: '125510', label: '125510 - BONOS DE FINANCIAMIENTO PRESUPUESTAL' },
  { value: '125515', label: '125515 - BONOS PARA DESARROLLO SOCIAL Y SEGURIDAD INTERNA (B.D.S.I.)' },
  { value: '125595', label: '125595 - OTRAS' },
  { value: '1260', label: '1260 - CUENTAS EN PARTICIPACION' },
  { value: '126099', label: '126099 - AJUSTES POR INFLACION' },
  { value: '1295', label: '1295 - OTRAS INVERSIONES' },
  { value: '129505', label: '129505 - APORTES EN COOPERATIVAS' },
  { value: '129510', label: '129510 - DERECHOS EN CLUBES SOCIALES' },
  { value: '129515', label: '129515 - ACCIONES O DERECHOS EN CLUBES DEPORTIVOS' },
  { value: '129520', label: '129520 - BONOS EN COLEGIOS' },
  { value: '129595', label: '129595 - DIVERSAS' },
  { value: '129599', label: '129599 - AJUSTES POR INFLACION' },
  { value: '1299', label: '1299 - PROVISIONES' },
  { value: '129905', label: '129905 - ACCIONES' },
  { value: '129910', label: '129910 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '129915', label: '129915 - BONOS' },
  { value: '129920', label: '129920 - CEDULAS' },
  { value: '129925', label: '129925 - CERTIFICADOS' },
  { value: '129930', label: '129930 - PAPELES COMERCIALES' },
  { value: '129935', label: '129935 - TITULOS' },
  { value: '129940', label: '129940 - ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: '129945', label: '129945 - DERECHOS FIDUCIARIOS' },
  { value: '129950', label: '129950 - DERECHOS DE RECOMPRA DE INVERSIONES NEGOCIADAS' },
  { value: '129955', label: '129955 - OBLIGATORIAS' },
  { value: '129960', label: '129960 - CUENTAS EN PARTICIPACION' },
  { value: '129995', label: '129995 - OTRAS INVERSIONES' },
  { value: '13', label: '13 - DEUDORES' },
  { value: '1305', label: '1305 - CLIENTES' },
  { value: '130505', label: '130505 - NACIONALES' },
  { value: '130510', label: '130510 - DEL EXTERIOR' },
  { value: '130515', label: '130515 - DEUDORES DEL SISTEMA' },
  { value: '1310', label: '1310 - CUENTAS CORRIENTES COMERCIALES' },
  { value: '131005', label: '131005 - CASA MATRIZ' },
  { value: '131010', label: '131010 - COMPAÑIAS VINCULADAS' },
  { value: '131015', label: '131015 - ACCIONISTAS O SOCIOS' },
  { value: '131020', label: '131020 - PARTICULARES' },
  { value: '131095', label: '131095 - OTRAS' },
  { value: '1315', label: '1315 - CUENTAS POR COBRAR A CASA MATRIZ' },
  { value: '131505', label: '131505 - VENTAS' },
  { value: '131510', label: '131510 - PAGOS A NOMBRE DE CASA MATRIZ' },
  { value: '131515', label: '131515 - VALORES RECIBIDOS POR CASA MATRIZ' },
  { value: '131520', label: '131520 - PRESTAMOS' },
  { value: '1320', label: '1320 - CUENTAS POR COBRAR A VINCULADOS ECONOMICOS' },
  { value: '132005', label: '132005 - FILIALES' },
  { value: '132010', label: '132010 - SUBSIDIARIAS' },
  { value: '132015', label: '132015 - SUCURSALES' },
  { value: '1325', label: '1325 - CUENTAS POR COBRAR A SOCIOS Y ACCIONISTAS' },
  { value: '132505', label: '132505 - A SOCIOS' },
  { value: '132510', label: '132510 - A ACCIONISTAS' },
  { value: '1328', label: '1328 - APORTES POR COBRAR' },
  { value: '1330', label: '1330 - ANTICIPOS Y AVANCES' },
  { value: '133005', label: '133005 - A PROVEEDORES' },
  { value: '133010', label: '133010 - A CONTRATISTAS' },
  { value: '133015', label: '133015 - A TRABAJADORES' },
  { value: '133020', label: '133020 - A AGENTES' },
  { value: '133025', label: '133025 - A CONCESIONARIOS' },
  { value: '133030', label: '133030 - DE ADJUDICACIONES' },
  { value: '133095', label: '133095 - OTROS' },
  { value: '1332', label: '1332 - CUENTAS DE OPERACION CONJUNTA' },
  { value: '1335', label: '1335 - DEPOSITOS' },
  { value: '133505', label: '133505 - PARA IMPORTACIONES' },
  { value: '133510', label: '133510 - PARA SERVICIOS' },
  { value: '133515', label: '133515 - PARA CONTRATOS' },
  { value: '133520', label: '133520 - PARA RESPONSABILIDADES' },
  { value: '133525', label: '133525 - PARA JUICIOS EJECUTIVOS' },
  { value: '133530', label: '133530 - PARA ADQUISICION DE ACCIONES, CUOTAS O DERECHOS' },
  { value: '133535', label: '133535 - EN GARANTIA' },
  { value: '133595', label: '133595 - OTROS' },
  { value: '1340', label: '1340 - PROMESAS DE COMPRA VENTA' },
  { value: '134005', label: '134005 - DE BIENES RAICES' },
  { value: '134010', label: '134010 - DE MAQUINARIA Y EQUIPO' },
  { value: '134015', label: '134015 - DE FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '134020', label: '134020 - DE FLOTA Y EQUIPO AEREO' },
  { value: '134025', label: '134025 - DE FLOTA Y EQUIPO FERREO' },
  { value: '134030', label: '134030 - DE FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '134035', label: '134035 - DE SEMOVIENTES' },
  { value: '134095', label: '134095 - DE OTROS BIENES' },
  { value: '1345', label: '1345 - INGRESOS POR COBRAR' },
  { value: '134505', label: '134505 - DIVIDENDOS Y/O PARTICIPACIONES' },
  { value: '134510', label: '134510 - INTERESES' },
  { value: '134515', label: '134515 - COMISIONES' },
  { value: '134520', label: '134520 - HONORARIOS' },
  { value: '134525', label: '134525 - SERVICIOS' },
  { value: '134530', label: '134530 - ARRENDAMIENTOS' },
  { value: '134535', label: '134535 - CERT POR COBRAR' },
  { value: '134595', label: '134595 - OTROS' },
  { value: '1350', label: '1350 - RETENCION SOBRE CONTRATOS' },
  { value: '135005', label: '135005 - DE CONSTRUCCION' },
  { value: '135010', label: '135010 - DE PRESTACION DE SERVICIOS' },
  { value: '135095', label: '135095 - OTROS' },
  { value: '1355', label: '1355 - ANTICIPO DE IMPUESTOS Y CONTRIBUCIONES O SALDOS A FAVOR' },
  { value: '135505', label: '135505 - ANTICIPO DE IMPUESTOS DE RENTA Y COMPLEMENTARIOS' },
  { value: '135510', label: '135510 - ANTICIPO DE IMPUESTOS DE INDUSTRIA Y COMERCIO' },
  { value: '135515', label: '135515 - RETENCION EN LA FUENTE' },
  { value: '135520', label: '135520 - SOBRANTES EN LIQUIDACION PRIVADA DE IMPUESTOS' },
  { value: '135525', label: '135525 - CONTRIBUCIONES' },
  { value: '135530', label: '135530 - IMPUESTOS DESCONTABLES' },
  { value: '135595', label: '135595 - OTROS' },
  { value: '1360', label: '1360 - RECLAMACIONES' },
  { value: '136005', label: '136005 - A COMPAÑIAS ASEGURADORAS' },
  { value: '136010', label: '136010 - A TRANSPORTADORES' },
  { value: '136015', label: '136015 - POR TIQUETES AEREOS' },
  { value: '136095', label: '136095 - OTRAS' },
  { value: '1365', label: '1365 - CUENTAS POR COBRAR A TRABAJADORES' },
  { value: '136505', label: '136505 - VIVIENDA' },
  { value: '136510', label: '136510 - VEHICULOS' },
  { value: '136515', label: '136515 - EDUCACION' },
  { value: '136520', label: '136520 - MEDICOS, ODONTOLOGICOS Y SIMILARES' },
  { value: '136525', label: '136525 - CALAMIDAD DOMESTICA' },
  { value: '136530', label: '136530 - RESPONSABILIDADES' },
  { value: '136595', label: '136595 - OTROS' },
  { value: '1370', label: '1370 - PRESTAMOS A PARTICULARES' },
  { value: '137005', label: '137005 - CON GARANTIA REAL' },
  { value: '137010', label: '137010 - CON GARANTIA PERSONAL' },
  { value: '1380', label: '1380 - DEUDORES VARIOS' },
  { value: '138005', label: '138005 - DEPOSITARIOS' },
  { value: '138010', label: '138010 - COMISIONISTAS DE BOLSAS' },
  { value: '138015', label: '138015 - FONDO DE INVERSION' },
  { value: '138020', label: '138020 - CUENTAS POR COBRAR DE TERCEROS' },
  { value: '138025', label: '138025 - PAGOS POR CUENTA DE TERCEROS' },
  { value: '138030', label: '138030 - FONDOS DE INVERSION SOCIAL' },
  { value: '138095', label: '138095 - OTROS' },
  { value: '1385', label: '1385 - DERECHOS DE RECOMPRA DE CARTERA NEGOCIADA' },
  { value: '1390', label: '1390 - DEUDAS DE DIFICIL COBRO' },
  { value: '1399', label: '1399 - PROVISIONES' },
  { value: '139905', label: '139905 - CLIENTES' },
  { value: '139910', label: '139910 - CUENTAS CORRIENTES COMERCIALES' },
  { value: '139915', label: '139915 - CUENTAS POR COBRAR A CASA MATRIZ' },
  { value: '139920', label: '139920 - CUENTAS POR COBRAR A VINCULADOS ECONOMICOS' },
  { value: '139925', label: '139925 - CUENTAS POR COBRAR A SOCIOS Y ACCIONISTAS' },
  { value: '139930', label: '139930 - ANTICIPOS Y AVANCES' },
  { value: '139932', label: '139932 - CUENTAS DE OPERACION CONJUNTA' },
  { value: '139935', label: '139935 - DEPOSITOS' },
  { value: '139940', label: '139940 - PROMESAS DE COMPRAVENTA' },
  { value: '139945', label: '139945 - INGRESOS POR COBRAR' },
  { value: '139950', label: '139950 - RETENCION SOBRE CONTRATOS' },
  { value: '139955', label: '139955 - RECLAMACIONES' },
  { value: '139960', label: '139960 - CUENTAS POR COBRAR A TRABAJADORES' },
  { value: '139965', label: '139965 - PRESTAMOS A PARTICULARES' },
  { value: '139975', label: '139975 - DEUDORES VARIOS' },
  { value: '139980', label: '139980 - DERECHOS DE RECOMPRA DE CARTERA NEGOCIADA' },
  { value: '14', label: '14 - INVENTARIOS' },
  { value: '1405', label: '1405 - MATERIAS PRIMAS' },
  { value: '140599', label: '140599 - AJUSTES POR INFLACION' },
  { value: '1410', label: '1410 - PRODUCTOS EN PROCESO' },
  { value: '141099', label: '141099 - AJUSTES POR INFLACION' },
  { value: '1415', label: '1415 - OBRAS DE CONSTRUCCION EN CURSO' },
  { value: '141599', label: '141599 - AJUSTES POR INFLACION' },
  { value: '1417', label: '1417 - OBRAS DE URBANISMO' },
  { value: '141799', label: '141799 - AJUSTES POR INFLACION' },
  { value: '1420', label: '1420 - CONTRATOS EN EJECUCION' },
  { value: '142099', label: '142099 - AJUSTES POR INFLACION' },
  { value: '1425', label: '1425 - CULTIVOS EN DESARROLLO' },
  { value: '142599', label: '142599 - AJUSTES POR INFLACION' },
  { value: '1430', label: '1430 - PRODUCTOS TERMINADOS' },
  { value: '143005', label: '143005 - PRODUCTOS MANUFACTURADOS' },
  { value: '143010', label: '143010 - PRODUCTOS EXTRAIDOS Y/O PROCESADOS' },
  { value: '143015', label: '143015 - PRODUCTOS AGRICOLAS Y FORESTALES' },
  { value: '143020', label: '143020 - SUBPRODUCTOS' },
  { value: '143025', label: '143025 - PRODUCTOS DE PESCA' },
  { value: '143099', label: '143099 - AJUSTES POR INFLACION' },
  { value: '1435', label: '1435 - MERCANCIAS NO FABRICADAS POR LA EMPRESA' },
  { value: '143599', label: '143599 - AJUSTES POR INFLACION' },
  { value: '1440', label: '1440 - BIENES RAICES PARA LA VENTA' },
  { value: '144099', label: '144099 - AJUSTES POR INFLACION' },
  { value: '1445', label: '1445 - SEMOVIENTES' },
  { value: '144505', label: '144505 - ESPECIES MAYORES' },
  { value: '144510', label: '144510 - ESPECIES MENORES' },
  { value: '144599', label: '144599 - AJUSTES POR INFLACION' },
  { value: '1450', label: '1450 - TERRENOS' },
  { value: '145005', label: '145005 - POR URBANIZAR' },
  { value: '145010', label: '145010 - URBANIZADOS POR CONSTRUIR' },
  { value: '145099', label: '145099 - AJUSTES POR INFLACION' },
  { value: '1455', label: '1455 - MATERIALES, REPUESTOS Y ACCESORIOS' },
  { value: '145505', label: '145505 - COMBUSTIBLES Y LUBRICANTES' },
  { value: '145510', label: '145510 - ABONOS Y FERTILIZANTES' },
  { value: '145515', label: '145515 - SEMILLAS TERMINADAS' },
  { value: '145520', label: '145520 - FUNGICIDAS Y HERBICIDAS' },
  { value: '145525', label: '145525 - MATERIALES Y REPUESTOS' },
  { value: '145530', label: '145530 - LOZA Y CRISTALERIA' },
  { value: '145535', label: '145535 - HERRAMIENTAS' },
  { value: '145540', label: '145540 - MEDICINAS' },
  { value: '145545', label: '145545 - ELEMENTOS HOSPITALARIOS' },
  { value: '145550', label: '145550 - INSTRUMENTAL QUIRURGICO' },
  { value: '145555', label: '145555 - DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: '145560', label: '145560 - ELEMENTOS DE ROPERIA Y LENCERIA' },
  { value: '145595', label: '145595 - OTROS' },
  { value: '145599', label: '145599 - AJUSTES POR INFLACION' },
  { value: '1460', label: '1460 - ENVASES Y EMPAQUES' },
  { value: '146099', label: '146099 - AJUSTES POR INFLACION' },
  { value: '1465', label: '1465 - INVENTARIOS EN TRANSITO' },
  { value: '146599', label: '146599 - AJUSTES POR INFLACION' },
  { value: '1499', label: '1499 - PROVISIONES' },
  { value: '149905', label: '149905 - PARA OBSOLESCENCIA' },
  { value: '149910', label: '149910 - PARA DIFERENCIA DE INVENTARIO FISICO' },
  { value: '149915', label: '149915 - PARA PERDIDAS DE INVENTARIOS' },
  { value: '149920', label: '149920 - LIFO' },
  { value: '15', label: '15 - PROPIEDADES PLANTA Y EQUIPO' },
  { value: '1504', label: '1504 - TERRENOS' },
  { value: '150405', label: '150405 - URBANOS' },
  { value: '150410', label: '150410 - RURALES' },
  { value: '150499', label: '150499 - AJUSTES POR INFLACION' },
  { value: '1506', label: '1506 - MATERIALES PROYECTOS PETROLEROS' },
  { value: '150605', label: '150605 - TUBERIAS Y EQUIPO' },
  { value: '150610', label: '150610 - COSTOS DE IMPORTACION MATERIALES' },
  { value: '150615', label: '150615 - PROYECTOS DE CONSTRUCCION' },
  { value: '150699', label: '150699 - AJUSTES POR INFLACION' },
  { value: '1508', label: '1508 - CONSTRUCCIONES EN CURSO' },
  { value: '150805', label: '150805 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '150810', label: '150810 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '150815', label: '150815 - VIAS DE COMUNICACION' },
  { value: '150820', label: '150820 - POZOS ARTESIANOS' },
  { value: '150825', label: '150825 - PROYECTOS DE EXPLORACION' },
  { value: '150830', label: '150830 - PROYECTOS DE DESARROLLO' },
  { value: '150899', label: '150899 - AJUSTES POR INFLACION' },
  { value: '1512', label: '1512 - MAQUINARIA Y EQUIPOS EN MONTAJE' },
  { value: '151205', label: '151205 - MAQUINARIA Y EQUIPO' },
  { value: '151210', label: '151210 - EQUIPO DE OFICINA' },
  { value: '151215', label: '151215 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '151220', label: '151220 - EQUIPO MEDICO-CIENTIFICO' },
  { value: '151225', label: '151225 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '151230', label: '151230 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '151235', label: '151235 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '151240', label: '151240 - FLOTA Y EQUIPO AEREO' },
  { value: '151245', label: '151245 - FLOTA Y EQUIPO FERREO' },
  { value: '151250', label: '151250 - PLANTAS Y REDES' },
  { value: '151299', label: '151299 - AJUSTES POR INFLACION' },
  { value: '1516', label: '1516 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '151605', label: '151605 - EDIFICIOS' },
  { value: '151610', label: '151610 - OFICINAS' },
  { value: '151615', label: '151615 - ALMACENES' },
  { value: '151620', label: '151620 - FABRICAS Y PLANTAS INDUSTRIALES' },
  { value: '151625', label: '151625 - SALAS DE EXHIBICION Y VENTAS' },
  { value: '151630', label: '151630 - CAFETERIA Y CASINOS' },
  { value: '151635', label: '151635 - SILOS' },
  { value: '151640', label: '151640 - INVERNADEROS' },
  { value: '151645', label: '151645 - CASETAS Y CAMPAMENTOS' },
  { value: '151650', label: '151650 - INSTALACIONES AGROPECUARIAS' },
  { value: '151655', label: '151655 - VIVIENDAS PARA EMPLEADOS Y OBREROS' },
  { value: '151660', label: '151660 - TERMINAL DE BUSES Y TAXIS' },
  { value: '151663', label: '151663 - TERMINAL MARITIMO' },
  { value: '151665', label: '151665 - TERMINAL FERREO' },
  { value: '151670', label: '151670 - PARQUEADEROS, GARAJES Y DEPOSITOS' },
  { value: '151675', label: '151675 - HANGARES' },
  { value: '151680', label: '151680 - BODEGAS' },
  { value: '151695', label: '151695 - OTROS' },
  { value: '151699', label: '151699 - AJUSTES POR INFLACION' },
  { value: '1520', label: '1520 - MAQUINARIA Y EQUIPO' },
  { value: '152099', label: '152099 - AJUSTES POR INFLACION' },
  { value: '1524', label: '1524 - EQUIPO DE OFICINA' },
  { value: '152405', label: '152405 - MUEBLES Y ENSERES' },
  { value: '152410', label: '152410 - EQUIPOS' },
  { value: '152495', label: '152495 - OTROS' },
  { value: '152499', label: '152499 - AJUSTES POR INFLACION' },
  { value: '1528', label: '1528 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '152805', label: '152805 - EQUIPOS DE PROCESAMIENTO DE DATOS' },
  { value: '152810', label: '152810 - EQUIPOS DE TELECOMUNICACIONES' },
  { value: '152815', label: '152815 - EQUIPOS DE RADIO' },
  { value: '152820', label: '152820 - SATELITES Y ANTENAS' },
  { value: '152825', label: '152825 - LINEAS TELEFONICAS' },
  { value: '152895', label: '152895 - OTROS' },
  { value: '152899', label: '152899 - AJUSTES POR INFLACION' },
  { value: '1532', label: '1532 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '153205', label: '153205 - MEDICO' },
  { value: '153210', label: '153210 - ODONTOLOGICO' },
  { value: '153215', label: '153215 - LABORATORIO' },
  { value: '153220', label: '153220 - INSTRUMENTAL' },
  { value: '153295', label: '153295 - OTROS' },
  { value: '153299', label: '153299 - AJUSTES POR INFLACION' },
  { value: '1536', label: '1536 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '153605', label: '153605 - DE HABITACIONES' },
  { value: '153610', label: '153610 - DE COMESTIBLES Y BEBIDAS' },
  { value: '153695', label: '153695 - OTROS' },
  { value: '153699', label: '153699 - AJUSTES POR INFLACION' },
  { value: '1540', label: '1540 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '154005', label: '154005 - AUTOS, CAMIONETAS Y CAMPEROS' },
  { value: '154008', label: '154008 - CAMIONES, VOLQUETAS Y FURGONES' },
  { value: '154010', label: '154010 - TRACTOMULAS Y REMOLQUES' },
  { value: '154015', label: '154015 - BUSES Y BUSETAS' },
  { value: '154017', label: '154017 - RECOLECTORES Y CONTENEDORES' },
  { value: '154020', label: '154020 - MONTACARGAS' },
  { value: '154025', label: '154025 - PALAS Y GRUAS' },
  { value: '154030', label: '154030 - MOTOCICLETAS' },
  { value: '154035', label: '154035 - BICICLETAS' },
  { value: '154040', label: '154040 - ESTIBAS Y CARRETAS' },
  { value: '154045', label: '154045 - BANDAS TRANSPORTADORAS' },
  { value: '154095', label: '154095 - OTROS' },
  { value: '154099', label: '154099 - AJUSTES POR INFLACION' },
  { value: '1544', label: '1544 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '154405', label: '154405 - BUQUES' },
  { value: '154410', label: '154410 - LANCHAS' },
  { value: '154415', label: '154415 - REMOLCADORAS' },
  { value: '154420', label: '154420 - BOTES' },
  { value: '154425', label: '154425 - BOYAS' },
  { value: '154430', label: '154430 - AMARRES' },
  { value: '154435', label: '154435 - CONTENEDORES Y CHASSISES' },
  { value: '154440', label: '154440 - GABARRAS' },
  { value: '154495', label: '154495 - OTROS' },
  { value: '154499', label: '154499 - AJUSTES POR INFLACION' },
  { value: '1548', label: '1548 - FLOTA Y EQUIPO AEREO' },
  { value: '154805', label: '154805 - AVIONES' },
  { value: '154810', label: '154810 - AVIONETAS' },
  { value: '154815', label: '154815 - HELICOPTEROS' },
  { value: '154820', label: '154820 - TURBINAS Y MOTORES' },
  { value: '154825', label: '154825 - MANUALES DE ENTRENAMIENTO PERSONAL TECNICO' },
  { value: '154830', label: '154830 - EQUIPOS DE VUELO' },
  { value: '154895', label: '154895 - OTROS' },
  { value: '154899', label: '154899 - AJUSTES POR INFLACION' },
  { value: '1552', label: '1552 - FLOTA Y EQUIPO FERREO' },
  { value: '155205', label: '155205 - LOCOMOTORAS' },
  { value: '155210', label: '155210 - VAGONES' },
  { value: '155215', label: '155215 - REDES FERREAS' },
  { value: '155295', label: '155295 - OTROS' },
  { value: '155299', label: '155299 - AJUSTES POR INFLACION' },
  { value: '1556', label: '1556 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '155605', label: '155605 - INSTALACIONES PARA AGUA Y ENERGIA' },
  { value: '155610', label: '155610 - ACUEDUCTO ACEQUIAS Y CANALIZACIONES' },
  { value: '155615', label: '155615 - PLANTAS DE GENERACION HIDRAULICA' },
  { value: '155620', label: '155620 - PLANTAS DE GENERACION TERMICA' },
  { value: '155625', label: '155625 - PLANTAS DE GENERACION A GAS' },
  { value: '155628', label: '155628 - PLANTAS DE GENERACION DIESEL, GASOLINA Y PETROLEO' },
  { value: '155630', label: '155630 - PLANTAS DE DISTRIBUCION' },
  { value: '155635', label: '155635 - PLANTAS DE TRANSMISION Y SUBESTACIONES' },
  { value: '155640', label: '155640 - OLEODUCTOS' },
  { value: '155645', label: '155645 - GASODUCTOS' },
  { value: '155647', label: '155647 - POLIDUCTOS' },
  { value: '155650', label: '155650 - REDES DE DISTRIBUCION' },
  { value: '155655', label: '155655 - PLANTAS DE TRATAMIENTO' },
  { value: '155660', label: '155660 - REDES DE RECOLECCION DE AGUAS NEGRAS' },
  { value: '155665', label: '155665 - INSTALACIONES Y EQUIPO DE BOMBEO' },
  { value: '155670', label: '155670 - REDES DE DISTRIBUCION DE VAPOR' },
  { value: '155675', label: '155675 - REDES DE AIRE' },
  { value: '155680', label: '155680 - REDES ALIMENTACION DE GAS' },
  { value: '155682', label: '155682 - REDES EXTERNAS DE TELEFONIA' },
  { value: '155685', label: '155685 - PLANTAS DESHIDRATADORAS' },
  { value: '155695', label: '155695 - OTROS' },
  { value: '155699', label: '155699 - AJUSTES POR INFLACION' },
  { value: '1560', label: '1560 - ARMAMENTO DE VIGILANCIA' },
  { value: '156099', label: '156099 - AJUSTES POR INFLACION' },
  { value: '1562', label: '1562 - ENVASES Y EMPAQUES' },
  { value: '156299', label: '156299 - AJUSTES POR INFLACION' },
  { value: '1564', label: '1564 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '156405', label: '156405 - CULTIVOS EN DESARROLLO' },
  { value: '156410', label: '156410 - CULTIVOS AMORTIZABLES' },
  { value: '156499', label: '156499 - AJUSTES POR INFLACION' },
  { value: '1568', label: '1568 - VIAS DE COMUNICACION' },
  { value: '156805', label: '156805 - PAVIMENTACION Y PATIOS' },
  { value: '156810', label: '156810 - VIAS' },
  { value: '156815', label: '156815 - PUENTES' },
  { value: '156820', label: '156820 - CALLES' },
  { value: '156825', label: '156825 - AERODROMOS' },
  { value: '156895', label: '156895 - OTROS' },
  { value: '156899', label: '156899 - AJUSTES POR INFLACION' },
  { value: '1572', label: '1572 - MINAS Y CANTERAS' },
  { value: '157205', label: '157205 - MINAS' },
  { value: '157210', label: '157210 - CANTERAS' },
  { value: '157299', label: '157299 - AJUSTES POR INFLACION' },
  { value: '1576', label: '1576 - POZOS ARTESIANOS' },
  { value: '157699', label: '157699 - AJUSTES POR INFLACION' },
  { value: '1580', label: '1580 - YACIMIENTOS' },
  { value: '158099', label: '158099 - AJUSTES POR INFLACION' },
  { value: '1584', label: '1584 - SEMOVIENTES' },
  { value: '158405', label: '158405 - ESPECIES MENORES' },
  { value: '158410', label: '158410 - ESPECIES MAYORES' },
  { value: '158499', label: '158499 - AJUSTES POR INFLACION' },
  { value: '1588', label: '1588 - PROPIEDADES PLANTA Y EQUIPO EN TRANSITO' },
  { value: '158805', label: '158805 - MAQUINARIA Y EQUIPO' },
  { value: '158810', label: '158810 - EQUIPO DE OFICINA' },
  { value: '158815', label: '158815 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '158820', label: '158820 - EQUIPO MEDICO CIENTIFICO' },
  { value: '158825', label: '158825 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '158830', label: '158830 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '158835', label: '158835 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '158840', label: '158840 - FLOTA Y EQUIPO AEREO' },
  { value: '158845', label: '158845 - FLOTA Y EQUIPO FERREO' },
  { value: '158850', label: '158850 - PLANTAS Y REDES' },
  { value: '158855', label: '158855 - ARMAMENTO DE VIGILANCIA' },
  { value: '158860', label: '158860 - SEMOVIENTES' },
  { value: '158865', label: '158865 - ENVASES Y EMPAQUES' },
  { value: '158899', label: '158899 - AJUSTES POR INFLACION' },
  { value: '1592', label: '1592 - DEPRECIACION ACUMULADA' },
  { value: '159205', label: '159205 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '159210', label: '159210 - MAQUINARIA Y EQUIPO' },
  { value: '159215', label: '159215 - EQUIPO DE OFICINA' },
  { value: '159220', label: '159220 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '159225', label: '159225 - EQUIPO MEDICO CIENTIFICO' },
  { value: '159230', label: '159230 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '159235', label: '159235 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '159240', label: '159240 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '159245', label: '159245 - FLOTA Y EQUIPO AEREO' },
  { value: '159250', label: '159250 - FLOTA Y EQUIPO FERREO' },
  { value: '159255', label: '159255 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '159260', label: '159260 - ARMAMENTO DE VIGILANCIA' },
  { value: '159265', label: '159265 - ENVASES Y EMPAQUES' },
  { value: '159299', label: '159299 - AJUSTES POR INFLACION' },
  { value: '1596', label: '1596 - DEPRECIACION DIFERIDA' },
  { value: '159605', label: '159605 - EXCESO FISCAL SOBRE LA CONTABLE' },
  { value: '159610', label: '159610 - DEFECTO FISCAL SOBRE LA CONTABLE (CR)' },
  { value: '159699', label: '159699 - AJUSTES POR INFLACION' },
  { value: '1597', label: '1597 - AMORTIZACION ACUMULADA' },
  { value: '159705', label: '159705 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '159710', label: '159710 - VIAS DE COMUNICACION' },
  { value: '159715', label: '159715 - SEMOVIENTES' },
  { value: '159799', label: '159799 - AJUSTES POR INFLACION' },
  { value: '1598', label: '1598 - AGOTAMIENTO ACUMULADO' },
  { value: '159805', label: '159805 - MINAS Y CANTERAS' },
  { value: '159815', label: '159815 - POZOS ARTESIANOS' },
  { value: '159820', label: '159820 - YACIMIENTOS' },
  { value: '159899', label: '159899 - AJUSTES POR INFLACION' },
  { value: '1599', label: '1599 - PROVISIONES' },
  { value: '159904', label: '159904 - TERRENOS' },
  { value: '159906', label: '159906 - MATERIALES PROYECTOS PETROLEROS' },
  { value: '159908', label: '159908 - CONSTRUCCIONES EN CURSO' },
  { value: '159912', label: '159912 - MAQUINARIA EN MONTAJE' },
  { value: '159916', label: '159916 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '159920', label: '159920 - MAQUINARIA Y EQUIPO' },
  { value: '159924', label: '159924 - EQUIPO DE OFICINA' },
  { value: '159928', label: '159928 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '159932', label: '159932 - EQUIPO MEDICO CIENTIFICO' },
  { value: '159936', label: '159936 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '159940', label: '159940 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '159944', label: '159944 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '159948', label: '159948 - FLOTA Y EQUIPO AEREO' },
  { value: '159952', label: '159952 - FLOTA Y EQUIPO FERREO' },
  { value: '159956', label: '159956 - ACUEDUCTOS, PLANTAS Y REDES' },
  { value: '159960', label: '159960 - ARMAMENTO DE VIGILANCIA' },
  { value: '159962', label: '159962 - ENVASES Y EMPAQUES' },
  { value: '159964', label: '159964 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '159968', label: '159968 - VIAS DE COMUNICACION' },
  { value: '159972', label: '159972 - MINAS Y CANTERAS' },
  { value: '159980', label: '159980 - POZOS ARTESIANOS' },
  { value: '159984', label: '159984 - YACIMIENTOS' },
  { value: '159988', label: '159988 - SEMOVIENTES' },
  { value: '159992', label: '159992 - PROPIEDADES PLANTA Y EQUIPO EN TRANSITO' },
  { value: '16', label: '16 - INTANGIBLES' },
  { value: '1605', label: '1605 - CREDITO MERCANTIL' },
  { value: '160505', label: '160505 - FORMADO O ESTIMADO' },
  { value: '160510', label: '160510 - ADQUIRIDO O COMPRADO' },
  { value: '160599', label: '160599 - AJUSTES POR INFLACION' },
  { value: '1610', label: '1610 - MARCAS' },
  { value: '161005', label: '161005 - ADQUIRIDAS' },
  { value: '161010', label: '161010 - FORMADAS' },
  { value: '161099', label: '161099 - AJUSTES POR INFLACION' },
  { value: '1615', label: '1615 - PATENTES' },
  { value: '161505', label: '161505 - ADQUIRIDAS' },
  { value: '161510', label: '161510 - FORMADAS' },
  { value: '161599', label: '161599 - AJUSTES POR INFLACION' },
  { value: '1620', label: '1620 - CONCESIONES Y FRANQUICIAS' },
  { value: '162005', label: '162005 - CONCESIONES' },
  { value: '162010', label: '162010 - FRANQUICIAS' },
  { value: '162099', label: '162099 - AJUSTES POR INFLACION' },
  { value: '1625', label: '1625 - DERECHOS' },
  { value: '162505', label: '162505 - DERECHOS DE AUTOR' },
  { value: '162510', label: '162510 - PUESTO DE BOLSA' },
  { value: '162515', label: '162515 - EN FIDEICOMISOS INMOBILIARIOS' },
  { value: '162520', label: '162520 - EN FIDEICOMISOS DE GARANTIA' },
  { value: '162525', label: '162525 - EN FIDEICOMISOS DE ADMINISTRACION' },
  { value: '162595', label: '162595 - OTROS' },
  { value: '162599', label: '162599 - AJUSTES POR INFLACION' },
  { value: '1630', label: '1630 - KNOW HOW' },
  { value: '163099', label: '163099 - AJUSTES POR INFLACION' },
  { value: '1635', label: '1635 - LICENCIAS' },
  { value: '163599', label: '163599 - AJUSTES POR INFLACION' },
  { value: '1698', label: '1698 - AMORTIZACION ACUMULADA' },
  { value: '169805', label: '169805 - CREDITO MERCANTIL' },
  { value: '169810', label: '169810 - MARCAS' },
  { value: '169815', label: '169815 - PATENTES' },
  { value: '169820', label: '169820 - CONCESIONES Y FRANQUICIAS' },
  { value: '169830', label: '169830 - DERECHOS' },
  { value: '169835', label: '169835 - KNOW HOW' },
  { value: '169840', label: '169840 - LICENCIAS' },
  { value: '169899', label: '169899 - AJUSTES POR INFLACION' },
  { value: '1699', label: '1699 - PROVISIONES' },
  { value: '17', label: '17 - DIFERIDOS' },
  { value: '1705', label: '1705 - GASTOS PAGADOS POR ANTICIPADO' },
  { value: '170505', label: '170505 - INTERESES' },
  { value: '170510', label: '170510 - HONORARIOS' },
  { value: '170515', label: '170515 - COMISIONES' },
  { value: '170520', label: '170520 - SEGUROS Y FIANZAS' },
  { value: '170525', label: '170525 - ARRENDAMIENTOS' },
  { value: '170530', label: '170530 - BODEGAJES' },
  { value: '170535', label: '170535 - MANTENIMIENTO EQUIPOS' },
  { value: '170540', label: '170540 - SERVICIOS' },
  { value: '170545', label: '170545 - SUSCRIPCIONES' },
  { value: '170595', label: '170595 - OTROS' },
  { value: '1710', label: '1710 - CARGOS DIFERIDOS' },
  { value: '171004', label: '171004 - ORGANIZACION Y PREOPERATIVOS' },
  { value: '171008', label: '171008 - REMODELACIONES' },
  { value: '171012', label: '171012 - ESTUDIOS, INVESTIGACIONES Y PROYECTOS' },
  { value: '171016', label: '171016 - PROGRAMAS PARA COMPUTADOR (SOFTWARE)' },
  { value: '171020', label: '171020 - UTILES Y PAPELERIA' },
  { value: '171024', label: '171024 - MEJORAS A PROPIEDADES AJENAS' },
  { value: '171028', label: '171028 - CONTRIBUCIONES Y AFILIACIONES' },
  { value: '171032', label: '171032 - ENTRENAMIENTO DE PERSONAL' },
  { value: '171036', label: '171036 - FERIAS Y EXPOSICIONES' },
  { value: '171040', label: '171040 - LICENCIAS' },
  { value: '171044', label: '171044 - PUBLICIDAD, PROPAGANDA Y AVISOS' },
  { value: '171048', label: '171048 - ELEMENTOS DE ASEO Y CAFETERIA' },
  { value: '171052', label: '171052 - MOLDES Y TROQUELES' },
  { value: '171056', label: '171056 - INSTRUMENTAL QUIRURGICO' },
  { value: '171060', label: '171060 - DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: '171064', label: '171064 - ELEMENTOS DE ROPERIA Y LENCERIA' },
  { value: '171068', label: '171068 - LOZA Y CRISTALERIA' },
  { value: '171072', label: '171072 - DESCUENTO EN COLOCACION DE BONOS' },
  { value: '171076', label: '171076 - IMPUESTO DE RENTA DIFERIDO "DEBITOS" POR DIFERENCIAS' },
  { value: '171080', label: '171080 - CONCURSOS Y LICITACIONES' },
  { value: '171095', label: '171095 - OTROS' },
  { value: '171099', label: '171099 - AJUSTES POR INFLACION' },
  { value: '1715', label: '1715 - COSTOS DE EXPLORACION POR AMORTIZAR' },
  { value: '171505', label: '171505 - POZOS SECOS' },
  { value: '171510', label: '171510 - POZOS NO COMERCIALES' },
  { value: '171515', label: '171515 - OTROS COSTOS DE EXPLORACION' },
  { value: '171599', label: '171599 - AJUSTES POR INFLACION' },
  { value: '1720', label: '1720 - COSTOS DE EXPLOTACION Y DESARROLLO' },
  { value: '172005', label: '172005 - PERFORACION Y EXPLOTACION' },
  { value: '172010', label: '172010 - PERFORACIONES CAMPOS EN DESARROLLO' },
  { value: '172015', label: '172015 - FACILIDADES DE PRODUCCION' },
  { value: '172020', label: '172020 - SERVICIO A POZOS' },
  { value: '172099', label: '172099 - AJUSTES POR INFLACION' },
  { value: '1730', label: '1730 - CARGOS POR CORRECCION MONETARIA DIFERIDA' },
  { value: '1798', label: '1798 - AMORTIZACION ACUMULADA' },
  { value: '179805', label: '179805 - COSTOS DE EXPLORACION POR AMORTIZAR' },
  { value: '179810', label: '179810 - COSTOS DE EXPLOTACION Y DESARROLLO' },
  { value: '179899', label: '179899 - AJUSTES POR INFLACION' },
  { value: '18', label: '18 - OTROS ACTIVOS' },
  { value: '1805', label: '1805 - BIENES DE ARTE Y CULTURA' },
  { value: '180505', label: '180505 - OBRAS DE ARTE' },
  { value: '180510', label: '180510 - BIBLIOTECAS' },
  { value: '180595', label: '180595 - OTROS' },
  { value: '180599', label: '180599 - AJUSTES POR INFLACION' },
  { value: '1895', label: '1895 - DIVERSOS' },
  { value: '189505', label: '189505 - MAQUINAS PORTEADORAS' },
  { value: '189510', label: '189510 - BIENES ENTREGADOS EN COMODATO' },
  { value: '189515', label: '189515 - AMORTIZACION ACUMULADA DE BIENES ENTREGADOS EN COMODATO (CR)' },
  { value: '189520', label: '189520 - BIENES RECIBIDOS EN PAGO' },
  { value: '189525', label: '189525 - DERECHOS SUCESORALES' },
  { value: '189530', label: '189530 - ESTAMPILLAS' },
  { value: '189595', label: '189595 - OTROS' },
  { value: '189599', label: '189599 - AJUSTES POR INFLACION' },
  { value: '1899', label: '1899 - PROVISIONES' },
  { value: '189905', label: '189905 - BIENES DE ARTE Y CULTURA' },
  { value: '189995', label: '189995 - DIVERSOS' },
  { value: '19', label: '19 - VALORIZACIONES' },
  { value: '1905', label: '1905 - DE INVERSIONES' },
  { value: '190505', label: '190505 - ACCIONES' },
  { value: '190510', label: '190510 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '190515', label: '190515 - DERECHOS FIDUCIARIOS' },
  { value: '1910', label: '1910 - DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: '191004', label: '191004 - TERRENOS' },
  { value: '191006', label: '191006 - MATERIALES PROYECTOS PETROLEROS' },
  { value: '191008', label: '191008 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '191012', label: '191012 - MAQUINARIA Y EQUIPO' },
  { value: '191016', label: '191016 - EQUIPO DE OFICINA' },
  { value: '191020', label: '191020 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '191024', label: '191024 - EQUIPO MEDICO CIENTIFICO' },
  { value: '191028', label: '191028 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '191032', label: '191032 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '191036', label: '191036 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '191040', label: '191040 - FLOTA Y EQUIPO AEREO' },
  { value: '191044', label: '191044 - FLOTA Y EQUIPO FERREO' },
  { value: '191048', label: '191048 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '191052', label: '191052 - ARMAMENTO DE VIGILANCIA' },
  { value: '191056', label: '191056 - ENVASES Y EMPAQUES' },
  { value: '191060', label: '191060 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '191064', label: '191064 - VIAS DE COMUNICACION' },
  { value: '191068', label: '191068 - MINAS Y CANTERAS' },
  { value: '191072', label: '191072 - POZOS ARTESIANOS' },
  { value: '191076', label: '191076 - YACIMIENTOS' },
  { value: '191080', label: '191080 - SEMOVIENTES' },
  { value: '1995', label: '1995 - DE OTROS ACTIVOS' },
  { value: '199505', label: '199505 - BIENES DE ARTE Y CULTURA' },
  { value: '199510', label: '199510 - BIENES ENTREGADOS EN COMODATO' },
  { value: '199515', label: '199515 - BIENES RECIBIDOS EN PAGO' },
  { value: '199520', label: '199520 - INVENTARIO DE SEMOVIENTES' },
  { value: '2', label: '2 - PASIVO' },
  { value: '21', label: '21 - OBLIGACIONES FINANCIERAS' },
  { value: '2105', label: '2105 - BANCOS NACIONALES' },
  { value: '210505', label: '210505 - SOBREGIROS' },
  { value: '210510', label: '210510 - PAGARES' },
  { value: '210515', label: '210515 - CARTAS DE CREDITO' },
  { value: '210520', label: '210520 - ACEPTACIONES BANCARIAS' },
  { value: '2110', label: '2110 - BANCOS DEL EXTERIOR' },
  { value: '211005', label: '211005 - SOBREGIROS' },
  { value: '211010', label: '211010 - PAGARES' },
  { value: '211015', label: '211015 - CARTAS DE CREDITO' },
  { value: '211020', label: '211020 - ACEPTACIONES BANCARIAS' },
  { value: '2115', label: '2115 - CORPORACIONES FINANCIERAS' },
  { value: '211505', label: '211505 - PAGARES' },
  { value: '211510', label: '211510 - ACEPTACIONES FINANCIERAS' },
  { value: '211515', label: '211515 - CARTAS DE CREDITO' },
  { value: '2120', label: '2120 - COMPAÑIAS DE FINANCIAMIENTO COMERCIAL' },
  { value: '212005', label: '212005 - PAGARES' },
  { value: '212010', label: '212010 - ACEPTACIONES FINANCIERAS' },
  { value: '2125', label: '2125 - CORPORACIONES DE AHORRO Y VIVIENDA' },
  { value: '212505', label: '212505 - SOBREGIROS' },
  { value: '212510', label: '212510 - PAGARES' },
  { value: '212515', label: '212515 - HIPOTECARIAS' },
  { value: '2130', label: '2130 - ENTIDADES FINANCIERAS DEL EXTERIOR' },
  { value: '2135', label: '2135 - COMPROMISOS DE RECOMPRA DE INVERSIONES NEGOCIADAS' },
  { value: '213505', label: '213505 - ACCIONES' },
  { value: '213510', label: '213510 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '213515', label: '213515 - BONOS' },
  { value: '213520', label: '213520 - CEDULAS' },
  { value: '213525', label: '213525 - CERTIFICADOS' },
  { value: '213530', label: '213530 - PAPELES COMERCIALES' },
  { value: '213535', label: '213535 - TITULOS' },
  { value: '213540', label: '213540 - ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: '213595', label: '213595 - OTROS' },
  { value: '2140', label: '2140 - COMPROMISOS DE RECOMPRA DE CARTERA NEGOCIADA' },
  { value: '2145', label: '2145 - OBLIGACIONES GUBERNAMENTALES' },
  { value: '214505', label: '214505 - GOBIERNO NACIONAL' },
  { value: '214510', label: '214510 - ENTIDADES OFICIALES' },
  { value: '2195', label: '2195 - OTRAS OBLIGACIONES' },
  { value: '219505', label: '219505 - PARTICULARES' },
  { value: '219510', label: '219510 - COMPAÑIAS VINCULADAS' },
  { value: '219515', label: '219515 - CASA MATRIZ' },
  { value: '219520', label: '219520 - SOCIOS O ACCIONISTAS' },
  { value: '219525', label: '219525 - FONDOS Y COOPERATIVAS' },
  { value: '219595', label: '219595 - OTRAS' },
  { value: '22', label: '22 - PROVEEDORES' },
  { value: '2205', label: '2205 - NACIONALES' },
  { value: '2210', label: '2210 - DEL EXTERIOR' },
  { value: '2215', label: '2215 - CUENTAS CORRIENTES COMERCIALES' },
  { value: '2220', label: '2220 - CASA MATRIZ' },
  { value: '2225', label: '2225 - COMPAÑIAS VINCULADAS' },
  { value: '23', label: '23 - CUENTAS POR PAGAR' },
  { value: '2305', label: '2305 - CUENTAS CORRIENTES COMERCIALES' },
  { value: '2310', label: '2310 - A CASA MATRIZ' },
  { value: '2315', label: '2315 - A COMPAÑIAS VINCULADAS' },
  { value: '2320', label: '2320 - A CONTRATISTAS' },
  { value: '2330', label: '2330 - ORDENES DE COMPRA POR UTILIZAR' },
  { value: '2335', label: '2335 - COSTOS Y GASTOS POR  PAGAR' },
  { value: '233505', label: '233505 - GASTOS FINANCIEROS' },
  { value: '233510', label: '233510 - GASTOS LEGALES' },
  { value: '233515', label: '233515 - LIBROS, SUSCRIPCIONES, PERIODICOS Y REVISTAS' },
  { value: '233520', label: '233520 - COMISIONES' },
  { value: '233525', label: '233525 - HONORARIOS' },
  { value: '233530', label: '233530 - SERVICIOS TECNICOS' },
  { value: '233535', label: '233535 - SERVICIOS DE MANTENIMIENTO' },
  { value: '233540', label: '233540 - ARRENDAMIENTOS' },
  { value: '233545', label: '233545 - TRANSPORTES, FLETES Y ACARREOS' },
  { value: '233550', label: '233550 - SERVICIOS PUBLICOS' },
  { value: '233555', label: '233555 - SEGUROS' },
  { value: '233560', label: '233560 - GASTOS DE VIAJE' },
  { value: '233565', label: '233565 - GASTOS DE REPRESENTACION Y RELACIONES PUBLICAS' },
  { value: '233570', label: '233570 - SERVICIOS ADUANEROS' },
  { value: '233595', label: '233595 - OTROS' },
  { value: '2340', label: '2340 - INSTALAMENTOS POR PAGAR' },
  { value: '2345', label: '2345 - ACREEDORES OFICIALES' },
  { value: '2350', label: '2350 - REGALIAS POR PAGAR' },
  { value: '2355', label: '2355 - DEUDAS CON ACCIONISTAS O SOCIOS' },
  { value: '235505', label: '235505 - ACCIONISTAS' },
  { value: '235510', label: '235510 - SOCIOS' },
  { value: '2360', label: '2360 - DIVIDENDOS O PARTICIPACIONES POR PAGAR' },
  { value: '236005', label: '236005 - DIVIDENDOS' },
  { value: '236010', label: '236010 - PARTICIPACIONES' },
  { value: '2365', label: '2365 - RETENCION EN LA FUENTE' },
  { value: '236505', label: '236505 - SALARIOS Y PAGOS LABORALES' },
  { value: '236510', label: '236510 - DIVIDENDOS Y/O PARTICIPACIONES' },
  { value: '236515', label: '236515 - HONORARIOS' },
  { value: '236520', label: '236520 - COMISIONES' },
  { value: '236525', label: '236525 - SERVICIOS' },
  { value: '236530', label: '236530 - ARRENDAMIENTOS' },
  { value: '236535', label: '236535 - RENDIMIENTOS FINANCIEROS' },
  { value: '236540', label: '236540 - COMPRAS' },
  { value: '236545', label: '236545 - LOTERIAS, RIFAS, APUESTAS Y SIMILARES' },
  { value: '236550', label: '236550 - POR PAGOS AL EXTERIOR' },
  { value: '236555', label: '236555 - POR INGRESOS OBTENIDOS EN EL EXTERIOR' },
  { value: '236560', label: '236560 - ENAJENACION PROPIEDADES PLANTA Y EQUIPO PERSONAS NATURALES' },
  { value: '236565', label: '236565 - POR IMPUESTO DE TIMBRE' },
  { value: '236570', label: '236570 - OTRAS RETENCIONES Y PATRIMONIO' },
  { value: '236575', label: '236575 - AUTORRETENCIONES' },
  { value: '2370', label: '2370 - RETENCIONES Y APORTES DE NOMINA' },
  { value: '237005', label: '237005 - APORTES AL I.S.S.' },
  { value: '237010', label: '237010 - APORTES AL I.C.B.F., SENA Y CAJAS DE COMPENSACION' },
  { value: '237015', label: '237015 - APORTES AL F.I.C.' },
  { value: '237025', label: '237025 - EMBARGOS JUDICIALES' },
  { value: '237030', label: '237030 - LIBRANZAS' },
  { value: '237035', label: '237035 - SINDICATOS' },
  { value: '237040', label: '237040 - COOPERATIVAS' },
  { value: '237045', label: '237045 - FONDOS' },
  { value: '237095', label: '237095 - OTROS' },
  { value: '2375', label: '2375 - CUOTAS POR DEVOLVER' },
  { value: '2380', label: '2380 - ACREEDORES VARIOS' },
  { value: '238005', label: '238005 - DEPOSITARIOS' },
  { value: '238010', label: '238010 - COMISIONISTAS DE BOLSAS' },
  { value: '238015', label: '238015 - SOCIEDAD ADMINISTRADORA - FONDOS DE INVERSION' },
  { value: '238020', label: '238020 - REINTEGROS POR PAGAR' },
  { value: '238025', label: '238025 - FONDO DE PERSEVERANCIA' },
  { value: '238030', label: '238030 - FONDOS DE CESANTIAS Y/O PENSIONES' },
  { value: '238035', label: '238035 - DONACIONES ASIGNADAS POR PAGAR' },
  { value: '238095', label: '238095 - OTROS' },
  { value: '24', label: '24 - IMPUESTOS, GRAVAMENES Y TASAS' },
  { value: '2404', label: '2404 - DE RENTA Y COMPLEMENTARIOS' },
  { value: '240405', label: '240405 - VIGENCIA FISCAL CORRIENTE' },
  { value: '240410', label: '240410 - VIGENCIAS FISCALES ANTERIORES' },
  { value: '2408', label: '2408 - IMPUESTO SOBRE LAS VENTAS POR PAGAR' },
  { value: '2412', label: '2412 - DE INDUSTRIA Y COMERCIO' },
  { value: '241205', label: '241205 - VIGENCIA FISCAL CORRIENTE' },
  { value: '241210', label: '241210 - VIGENCIAS FISCALES ANTERIORES' },
  { value: '2416', label: '2416 - A LA PROPIEDAD RAIZ' },
  { value: '2420', label: '2420 - DERECHOS SOBRE INSTRUMENTOS PUBLICOS' },
  { value: '2424', label: '2424 - DE VALORIZACION' },
  { value: '242405', label: '242405 - VIGENCIA FISCAL CORRIENTE' },
  { value: '242410', label: '242410 - VIGENCIAS FISCALES ANTERIORES' },
  { value: '2428', label: '2428 - DE TURISMO' },
  { value: '2432', label: '2432 - TASA POR UTILIZACION DE PUERTOS' },
  { value: '2436', label: '2436 - DE VEHICULOS' },
  { value: '243605', label: '243605 - VIGENCIA FISCAL CORRIENTE' },
  { value: '243610', label: '243610 - VIGENCIAS FISCALES ANTERIORES' },
  { value: '2440', label: '2440 - DE ESPECTACULOS PUBLICOS' },
  { value: '2444', label: '2444 - DE HIDROCARBUROS Y MINAS' },
  { value: '244405', label: '244405 - DE HIDROCARBUROS' },
  { value: '244410', label: '244410 - DE MINAS' },
  { value: '2448', label: '2448 - REGALIAS E IMPUESTOS A LA PEQUEÑA Y MEDIANA MINERIA' },
  { value: '2452', label: '2452 - A LAS EXPORTACIONES CAFETERAS' },
  { value: '2456', label: '2456 - A LAS IMPORTACIONES' },
  { value: '2460', label: '2460 - CUOTAS DE FOMENTO' },
  { value: '2464', label: '2464 - DE LICORES, CERVEZAS Y CIGARRILLOS' },
  { value: '246405', label: '246405 - DE LICORES' },
  { value: '246410', label: '246410 - DE CERVEZAS' },
  { value: '246415', label: '246415 - DE CIGARRILLOS' },
  { value: '2468', label: '2468 - AL SACRIFICIO DE GANADO' },
  { value: '2472', label: '2472 - AL AZAR Y JUEGOS' },
  { value: '2495', label: '2495 - OTROS' },
  { value: '25', label: '25 - OBLIGACIONES LABORALES' },
  { value: '2505', label: '2505 - SALARIOS POR PAGAR' },
  { value: '2510', label: '2510 - CESANTIAS CONSOLIDADAS' },
  { value: '251005', label: '251005 - LEY LABORAL ANTERIOR' },
  { value: '251010', label: '251010 - LEY 50 DE 1990 Y NORMAS POSTERIORES' },
  { value: '2515', label: '2515 - INTERESES SOBRE CESANTIAS' },
  { value: '2520', label: '2520 - PRIMA DE SERVICIOS' },
  { value: '2525', label: '2525 - VACACIONES CONSOLIDADAS' },
  { value: '252501', label: '252501 - a 252598' },
  { value: '2530', label: '2530 - PRESTACIONES EXTRALEGALES' },
  { value: '253005', label: '253005 - PRIMAS' },
  { value: '253010', label: '253010 - AUXILIOS' },
  { value: '253015', label: '253015 - DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: '253020', label: '253020 - BONIFICACIONES' },
  { value: '253025', label: '253025 - SEGUROS' },
  { value: '253095', label: '253095 - OTRAS' },
  { value: '2532', label: '2532 - PENSIONES POR PAGAR' },
  { value: '2535', label: '2535 - CUOTAS PARTES PENSIONES DE JUBILACION' },
  { value: '2540', label: '2540 - INDEMNIZACIONES LABORALES' },
  { value: '26', label: '26 - PASIVOS ESTIMADOS Y PROVISIONES' },
  { value: '2605', label: '2605 - PARA COSTOS Y GASTOS' },
  { value: '260505', label: '260505 - INTERESES' },
  { value: '260510', label: '260510 - COMISIONES' },
  { value: '260515', label: '260515 - HONORARIOS' },
  { value: '260520', label: '260520 - SERVICIOS TECNICOS' },
  { value: '260525', label: '260525 - TRANSPORTES, FLETES Y ACARREOS' },
  { value: '260530', label: '260530 - GASTOS DE VIAJE' },
  { value: '260535', label: '260535 - SERVICIOS PUBLICOS' },
  { value: '260540', label: '260540 - REGALIAS' },
  { value: '260545', label: '260545 - GARANTIAS' },
  { value: '260550', label: '260550 - MATERIALES Y REPUESTOS' },
  { value: '260595', label: '260595 - OTROS' },
  { value: '2610', label: '2610 - PARA OBLIGACIONES LABORALES' },
  { value: '261005', label: '261005 - CESANTIAS' },
  { value: '261010', label: '261010 - INTERESES SOBRE CESANTIAS' },
  { value: '261015', label: '261015 - VACACIONES' },
  { value: '261020', label: '261020 - PRIMA DE SERVICIOS' },
  { value: '261025', label: '261025 - PRESTACIONES EXTRALEGALES' },
  { value: '261030', label: '261030 - VIATICOS' },
  { value: '261095', label: '261095 - OTRAS' },
  { value: '2615', label: '2615 - PARA OBLIGACIONES FISCALES' },
  { value: '261505', label: '261505 - DE RENTA Y COMPLEMENTARIOS' },
  { value: '261510', label: '261510 - DE INDUSTRIA Y COMERCIO' },
  { value: '261515', label: '261515 - TASA POR UTILIZACION DE PUERTOS' },
  { value: '261520', label: '261520 - DE VEHICULOS' },
  { value: '261525', label: '261525 - DE HIDROCARBUROS Y MINAS' },
  { value: '261595', label: '261595 - OTROS' },
  { value: '2620', label: '2620 - PENSIONES DE JUBILACION' },
  { value: '262005', label: '262005 - CALCULO ACTUARIAL PENSIONES DE JUBILACION' },
  { value: '262010', label: '262010 - PENSIONES DE JUBILACION POR AMORTIZAR (DB)' },
  { value: '2625', label: '2625 - PARA OBRAS DE URBANISMO' },
  { value: '262505', label: '262505 - ACUEDUCTO Y ALCANTARILLADO' },
  { value: '262510', label: '262510 - ENERGIA ELECTRICA' },
  { value: '262515', label: '262515 - TELEFONOS' },
  { value: '262595', label: '262595 - OTROS' },
  { value: '2630', label: '2630 - PARA MANTENIMIENTO Y REPARACIONES' },
  { value: '263005', label: '263005 - TERRENOS' },
  { value: '263010', label: '263010 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '263015', label: '263015 - MAQUINARIA Y EQUIPO' },
  { value: '263020', label: '263020 - EQUIPO DE OFICINA' },
  { value: '263025', label: '263025 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '263030', label: '263030 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '263035', label: '263035 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '263040', label: '263040 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '263045', label: '263045 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '263050', label: '263050 - FLOTA Y EQUIPO AEREO' },
  { value: '263055', label: '263055 - FLOTA Y EQUIPO FERREO' },
  { value: '263060', label: '263060 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '263065', label: '263065 - ARMAMENTO DE VIGILANCIA' },
  { value: '263070', label: '263070 - ENVASES Y EMPAQUES' },
  { value: '263075', label: '263075 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '263080', label: '263080 - VIAS DE CUMUNICACION' },
  { value: '263085', label: '263085 - POZOS ARTESIANOS' },
  { value: '263095', label: '263095 - OTROS' },
  { value: '2635', label: '2635 - PARA CONTINGENCIAS' },
  { value: '263505', label: '263505 - MULTAS Y SANCIONES AUTORIDADES ADMINISTRATIVAS' },
  { value: '263510', label: '263510 - INTERESES POR MULTAS Y SANCIONES' },
  { value: '263515', label: '263515 - RECLAMOS' },
  { value: '263520', label: '263520 - LABORALES' },
  { value: '263525', label: '263525 - CIVILES' },
  { value: '263530', label: '263530 - PENALES' },
  { value: '263535', label: '263535 - ADMINISTRATIVOS' },
  { value: '263540', label: '263540 - COMERCIALES' },
  { value: '263595', label: '263595 - OTRAS' },
  { value: '2640', label: '2640 - PARA OBLIGACIONES DE GARANTIAS' },
  { value: '2695', label: '2695 - PROVISIONES DIVERSAS' },
  { value: '269505', label: '269505 - PARA BENEFICENCIA' },
  { value: '269510', label: '269510 - PARA COMUNICACIONES' },
  { value: '269515', label: '269515 - PARA PERDIDA EN TRANSPORTE' },
  { value: '269520', label: '269520 - PARA OPERACION' },
  { value: '269525', label: '269525 - PARA PROTECCION DE BIENES AGOTABLES' },
  { value: '269530', label: '269530 - PARA AJUSTES EN REDENCION DE UNIDADES' },
  { value: '269535', label: '269535 - AUTOSEGURO' },
  { value: '269540', label: '269540 - PLANES Y PROGRAMAS DE REFORESTACION Y ELECTRIFICACION' },
  { value: '269595', label: '269595 - OTRAS' },
  { value: '27', label: '27 - DIFERIDOS' },
  { value: '2705', label: '2705 - INGRESOS RECIBIDOS POR ANTICIPADO' },
  { value: '270505', label: '270505 - INTERESES' },
  { value: '270510', label: '270510 - COMISIONES' },
  { value: '270515', label: '270515 - ARRENDAMIENTOS' },
  { value: '270520', label: '270520 - HONORARIOS' },
  { value: '270525', label: '270525 - SERVICIOS TECNICOS' },
  { value: '270530', label: '270530 - DE SUSCRIPTORES' },
  { value: '270535', label: '270535 - TRANSPORTES, FLETES Y ACARREOS' },
  { value: '270540', label: '270540 - MERCANCIA EN TRANSITO YA VENDIDA' },
  { value: '270545', label: '270545 - MATRICULAS Y PENSIONES' },
  { value: '270550', label: '270550 - CUOTAS DE ADMINISTRACION' },
  { value: '270595', label: '270595 - OTROS' },
  { value: '2710', label: '2710 - ABONOS DIFERIDOS' },
  { value: '271005', label: '271005 - REAJUSTE DEL SISTEMA' },
  { value: '2715', label: '2715 - UTILIDAD DIFERIDA EN VENTAS A PLAZOS' },
  { value: '2720', label: '2720 - CREDITO POR CORRECCION MONETARIA DIFERIDA' },
  { value: '2725', label: '2725 - IMPUESTOS DIFERIDOS' },
  { value: '272505', label: '272505 - POR DEPRECIACION FLEXIBLE' },
  { value: '272595', label: '272595 - DIVERSOS' },
  { value: '272599', label: '272599 - AJUSTES POR INFLACION' },
  { value: '28', label: '28 - OTROS PASIVOS' },
  { value: '2805', label: '2805 - ANTICIPOS Y AVANCES RECIBIDOS' },
  { value: '280505', label: '280505 - DE CLIENTES' },
  { value: '280510', label: '280510 - SOBRE CONTRATOS' },
  { value: '280515', label: '280515 - PARA OBRAS EN PROCESO' },
  { value: '280595', label: '280595 - OTROS' },
  { value: '2810', label: '2810 - DEPOSITOS RECIBIDOS' },
  { value: '281005', label: '281005 - PARA FUTURA SUSCRIPCION DE ACCIONES' },
  { value: '281010', label: '281010 - PARA FUTURO PAGO DE CUOTAS O DERECHOS SOCIALES' },
  { value: '281015', label: '281015 - PARA GARANTIA EN LA PRESTACION DE SERVICIOS' },
  { value: '281020', label: '281020 - PARA GARANTIA DE CONTRATOS' },
  { value: '281025', label: '281025 - DE LICITACIONES' },
  { value: '281030', label: '281030 - DE MANEJO DE BIENES' },
  { value: '281035', label: '281035 - FONDO DE RESERVA' },
  { value: '281095', label: '281095 - OTROS' },
  { value: '2815', label: '2815 - INGRESOS RECIBIDOS PARA TERCEROS' },
  { value: '281505', label: '281505 - VALORES RECIBIDOS PARA TERCEROS' },
  { value: '281510', label: '281510 - VENTA POR CUENTA DE TERCEROS' },
  { value: '2820', label: '2820 - CUENTAS DE OPERACION CONJUNTA' },
  { value: '2825', label: '2825 - RETENCIONES A TERCEROS SOBRE CONTRATOS' },
  { value: '282505', label: '282505 - CUMPLIMIENTO OBLIGACIONES LABORALES' },
  { value: '282510', label: '282510 - PARA ESTABILIDAD DE OBRA' },
  { value: '282515', label: '282515 - GARANTIA CUMPLIMIENTO DE CONTRATOS' },
  { value: '2830', label: '2830 - EMBARGOS JUDICIALES' },
  { value: '283005', label: '283005 - INDEMNIZACIONES' },
  { value: '283010', label: '283010 - DEPOSITOS JUDICIALES' },
  { value: '2835', label: '2835 - ACREEDORES DEL SISTEMA' },
  { value: '283505', label: '283505 - CUOTAS NETAS' },
  { value: '283510', label: '283510 - GRUPOS EN FORMACION' },
  { value: '2840', label: '2840 - CUENTAS EN PARTICIPACION' },
  { value: '2895', label: '2895 - DIVERSOS' },
  { value: '289505', label: '289505 - PRESTAMOS DE PRODUCTOS' },
  { value: '289510', label: '289510 - REEMBOLSO DE COSTOS EXPLORATORIOS' },
  { value: '289515', label: '289515 - PROGRAMA DE EXTENSION AGROPECUARIA' },
  { value: '29', label: '29 - BONOS Y PAPELES COMERCIALES' },
  { value: '2905', label: '2905 - BONOS EN CIRCULACION' },
  { value: '290505', label: '290505 - GARANTIA GENERAL' },
  { value: '290510', label: '290510 - GARANTIA ESPECIFICA' },
  { value: '2910', label: '2910 - BONOS OBLIGATORIAMENTE CONVERTIBLES EN ACCIONES' },
  { value: '2915', label: '2915 - PAPELES COMERCIALES' },
  { value: '3', label: '3 - PATRIMONIO' },
  { value: '31', label: '31 - CAPITAL SOCIAL' },
  { value: '3105', label: '3105 - CAPITAL SUSCRITO Y PAGADO' },
  { value: '310505', label: '310505 - CAPITAL AUTORIZADO' },
  { value: '310510', label: '310510 - CAPITAL POR SUSCRIBIR (DB)' },
  { value: '310515', label: '310515 - CAPITAL SUSCRITO POR COBRAR (DB)' },
  { value: '3110', label: '3110 - ACCIONES, CUOTAS O PARTES DE INTERES SOCIAL PROPIAS READQUIRIDAS (DB)' },
  { value: '311005', label: '311005 - ACCIONES PROPIAS READQUIRIDAS (DB)' },
  { value: '311010', label: '311010 - CUOTAS O PARTES DE INTERES SOCIAL PROPIAS READQUIRIDAS (DB)' },
  { value: '3115', label: '3115 - APORTES SOCIALES' },
  { value: '311505', label: '311505 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '311510', label: '311510 - APORTES DE SOCIOS - FONDO MUTUO DE INVERSION' },
  { value: '311515', label: '311515 - CONTRIBUCION DE LA EMPRESA - FONDO MUTUO DE INVERSION' },
  { value: '311520', label: '311520 - SUSCRIPCIONES DEL PUBLICO' },
  { value: '3120', label: '3120 - CAPITAL ASIGNADO' },
  { value: '3125', label: '3125 - INVERSION SUPLEMENTARIA AL CAPITAL ASIGNADO' },
  { value: '3130', label: '3130 - CAPITAL DE PERSONAS NATURALES' },
  { value: '3135', label: '3135 - APORTES DEL ESTADO' },
  { value: '3140', label: '3140 - FONDO SOCIAL' },
  { value: '32', label: '32 - SUPERAVIT DE CAPITAL' },
  { value: '3205', label: '3205 - PRIMA EN COLOCACION DE ACCIONES, CUOTAS O PARTES DE INTERES' },
  { value: '320505', label: '320505 - PRIMA EN COLOCACION DE ACCIONES' },
  { value: '320510', label: '320510 - PRIMA EN COLOCACION DE ACCIONES POR COBRAR (DB)' },
  { value: '320515', label: '320515 - PRIMA EN COLOCACION DE CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '3210', label: '3210 - DONACIONES' },
  { value: '321005', label: '321005 - EN DINERO' },
  { value: '321010', label: '321010 - EN VALORES MOBILIARIOS' },
  { value: '321015', label: '321015 - EN BIENES MUEBLES' },
  { value: '321020', label: '321020 - EN BIENES INMUEBLES' },
  { value: '321025', label: '321025 - EN INTANGIBLES' },
  { value: '3215', label: '3215 - CREDITO MERCANTIL' },
  { value: '33', label: '33 - RESERVAS' },
  { value: '3305', label: '3305 - RESERVAS OBLIGATORIAS' },
  { value: '330505', label: '330505 - RESERVA LEGAL' },
  { value: '330510', label: '330510 - RESERVAS POR DISPOSICIONES FISCALES' },
  { value: '330515', label: '330515 - RESERVA PARA READQUISICION DE ACCIONES' },
  { value: '330517', label: '330517 - RESERVA PARA READQUISICION DE CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '330520', label: '330520 - RESERVA PARA EXTENSION AGROPECUARIA' },
  { value: '330525', label: '330525 - RESERVA LEY 7a. DE 1990' },
  { value: '330530', label: '330530 - RESERVA PARA REPOSICION DE SEMOVIENTES' },
  { value: '330535', label: '330535 - RESERVA LEY 4a DE 1980' },
  { value: '330595', label: '330595 - OTRAS' },
  { value: '3310', label: '3310 - RESERVAS ESTATUTARIAS' },
  { value: '331005', label: '331005 - PARA FUTURAS CAPITALIZACIONES' },
  { value: '331010', label: '331010 - PARA REPOSICION DE ACTIVOS' },
  { value: '331015', label: '331015 - PARA FUTUROS ENSANCHES' },
  { value: '331095', label: '331095 - OTRAS' },
  { value: '3315', label: '3315 - RESERVAS OCASIONALES' },
  { value: '331505', label: '331505 - PARA BENEFICENCIA Y CIVISMO' },
  { value: '331510', label: '331510 - PARA FUTURAS CAPITALIZACIONES' },
  { value: '331515', label: '331515 - PARA FUTUROS ENSANCHES' },
  { value: '331520', label: '331520 - PARA ADQUISICION O REPOSICION DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: '331525', label: '331525 - PARA INVESTIGACIONES Y DESARROLLO' },
  { value: '331530', label: '331530 - PARA FOMENTO ECONOMICO' },
  { value: '331535', label: '331535 - PARA CAPITAL DE TRABAJO' },
  { value: '331540', label: '331540 - PARA ESTABILIZACION DE RENDIMIENTOS' },
  { value: '331545', label: '331545 - A DISPOSICION DEL MAXIMO ORGANO SOCIAL' },
  { value: '331595', label: '331595 - OTRAS' },
  { value: '34', label: '34 - REVALORIZACION DEL PATRIMONIO' },
  { value: '3405', label: '3405 - AJUSTES POR INFLACION' },
  { value: '340505', label: '340505 - DE CAPITAL SOCIAL' },
  { value: '340510', label: '340510 - DE SUPERAVIT DE CAPITAL' },
  { value: '340515', label: '340515 - DE RESERVAS' },
  { value: '340520', label: '340520 - DE RESULTADOS DE EJERCICIOS ANTERIORES' },
  { value: '340525', label: '340525 - DE ACTIVOS EN PERIODO IMPRODUCTIVO' },
  { value: '3410', label: '3410 - SANEAMIENTO FISCAL' },
  { value: '3415', label: '3415 - AJUSTES POR INFLACION DECRETO 3019 DE 1989' },
  { value: '35', label: '35 - DIVIDENDOS O PARTICIPACIONES DECRETADOS EN ACCIONES, CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '3505', label: '3505 - DIVIDENDOS DECRETADOS EN ACCIONES' },
  { value: '3510', label: '3510 - PARTICIPACIONES DECRETADAS EN CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '36', label: '36 - RESULTADOS DEL EJERCICIO' },
  { value: '3605', label: '3605 - UTILIDAD DEL EJERCICIO' },
  { value: '360505', label: '360505 - UTILIDAD DEL EJERCICIO' },
  { value: '360510', label: '360510 - UTILIDAD POR EXPOSICION A LA INFLACION' },
  { value: '3610', label: '3610 - PERDIDA DEL EJERCICIO' },
  { value: '361005', label: '361005 - PERDIDA DEL EJERCICIO' },
  { value: '361010', label: '361010 - PERDIDA POR EXPOSICION A LA INFLACION' },
  { value: '37', label: '37 - RESULTADOS DE EJERCICIOS ANTERIORES' },
  { value: '3705', label: '3705 - UTILIDADES O EXCEDENTES ACUMULADOS' },
  { value: '3710', label: '3710 - PERDIDAS ACUMULADAS' },
  { value: '38', label: '38 - SUPERAVIT POR VALORIZACIONES' },
  { value: '3805', label: '3805 - DE INVERSIONES' },
  { value: '380505', label: '380505 - ACCIONES' },
  { value: '380510', label: '380510 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '380515', label: '380515 - DERECHOS FIDUCIARIOS' },
  { value: '3810', label: '3810 - DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: '381004', label: '381004 - TERRENOS' },
  { value: '381006', label: '381006 - MATERIALES PROYECTOS PETROLEROS' },
  { value: '381008', label: '381008 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '381012', label: '381012 - MAQUINARIA Y EQUIPO' },
  { value: '381016', label: '381016 - EQUIPO DE OFICINA' },
  { value: '381020', label: '381020 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '381024', label: '381024 - EQUIPO MEDICO CIENTIFICO' },
  { value: '381028', label: '381028 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '381032', label: '381032 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '381036', label: '381036 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '381040', label: '381040 - FLOTA Y EQUIPO AEREO' },
  { value: '381044', label: '381044 - FLOTA Y EQUIPO FERREO' },
  { value: '381048', label: '381048 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '381052', label: '381052 - ARMAMENTO DE VIGILANCIA' },
  { value: '381056', label: '381056 - ENVASES Y EMPAQUES' },
  { value: '381060', label: '381060 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '381064', label: '381064 - VIAS DE COMUNICACION' },
  { value: '381068', label: '381068 - MINAS Y CANTERAS' },
  { value: '381072', label: '381072 - POZOS ARTESIANOS' },
  { value: '381076', label: '381076 - YACIMIENTOS' },
  { value: '381080', label: '381080 - SEMOVIENTES' },
  { value: '3895', label: '3895 - DE OTROS ACTIVOS' },
  { value: '389505', label: '389505 - BIENES DE ARTE Y CULTURA' },
  { value: '389510', label: '389510 - BIENES ENTREGADOS EN COMODATO' },
  { value: '389515', label: '389515 - BIENES RECIBIDOS EN PAGO' },
  { value: '389520', label: '389520 - INVENTARIO DE SEMOVIENTES' },
  { value: '4', label: '4 - INGRESOS' },
  { value: '41', label: '41 - OPERACIONALES' },
  { value: '4105', label: '4105 - AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: '410505', label: '410505 - CULTIVO DE CEREALES' },
  { value: '410510', label: '410510 - CULTIVOS DE HORTALIZAS, LEGUMBRES Y PLANTAS ORNAMENTALES' },
  { value: '410515', label: '410515 - CULTIVOS DE FRUTAS, NUECES Y PLANTAS AROMATICAS' },
  { value: '410520', label: '410520 - CULTIVO DE CAFE' },
  { value: '410525', label: '410525 - CULTIVO DE FLORES' },
  { value: '410530', label: '410530 - CULTIVO DE CAÑA DE AZUCAR' },
  { value: '410535', label: '410535 - CULTIVO DE ALGODON Y PLANTAS PARA MATERIAL TEXTIL' },
  { value: '410540', label: '410540 - CULTIVO DE BANANO' },
  { value: '410545', label: '410545 - OTROS CULTIVOS AGRICOLAS' },
  { value: '410550', label: '410550 - CRIA DE OVEJAS, CABRAS, ASNOS, MULAS Y BURDEGANOS' },
  { value: '410555', label: '410555 - CRIA DE GANADO CABALLAR Y VACUNO.' },
  { value: '410560', label: '410560 - PRODUCCION AVICOLA' },
  { value: '410565', label: '410565 - CRIA DE OTROS ANIMALES' },
  { value: '410570', label: '410570 - SERVICIOS AGRICOLAS Y GANADEROS' },
  { value: '410575', label: '410575 - ACTIVIDAD DE CAZA' },
  { value: '410580', label: '410580 - ACTIVIDAD DE SILVICULTURA' },
  { value: '410599', label: '410599 - AJUSTES POR INFLACION' },
  { value: '4110', label: '4110 - PESCA' },
  { value: '411005', label: '411005 - ACTIVIDAD DE PESCA' },
  { value: '411010', label: '411010 - EXPLOTACION DE CRIADEROS DE PECES' },
  { value: '411095', label: '411095 - ACTIVIDADES CONEXAS' },
  { value: '411099', label: '411099 - AJUSTES POR INFLACION' },
  { value: '4115', label: '4115 - EXPLOTACION DE MINAS Y CANTERAS' },
  { value: '411505', label: '411505 - CARBON' },
  { value: '411510', label: '411510 - PETROLEO CRUDO' },
  { value: '411512', label: '411512 - GAS NATURAL' },
  { value: '411514', label: '411514 - SERVICIOS RELACIONADOS CON EXTRACCION DE PETROLEO Y GAS' },
  { value: '411515', label: '411515 - MINERALES DE HIERRO' },
  { value: '411520', label: '411520 - MINERALES METALIFEROS NO FERROSOS' },
  { value: '411525', label: '411525 - PIEDRA, ARENA Y ARCILLA' },
  { value: '411527', label: '411527 - PIEDRAS PRECIOSAS' },
  { value: '411528', label: '411528 - ORO' },
  { value: '411530', label: '411530 - OTRAS MINAS Y CANTERAS' },
  { value: '411532', label: '411532 - PRESTACION DE SERVICIOS SECTOR MINERO' },
  { value: '411595', label: '411595 - ACTIVIDADES CONEXAS' },
  { value: '411599', label: '411599 - AJUSTES POR INFLACION' },
  { value: '4120', label: '4120 - INDUSTRIAS MANUFACTURERAS' },
  { value: '412001', label: '412001 - PRODUCCION Y PROCESAMIENTO DE CARNES Y PRODUCTOS CARNICOS' },
  { value: '412002', label: '412002 - PRODUCTOS DE PESCADO' },
  { value: '412003', label: '412003 - PRODUCTOS DE FRUTAS, LEGUMBRES Y HORTALIZAS' },
  { value: '412004', label: '412004 - ELABORACION DE ACEITES Y GRASAS' },
  { value: '412005', label: '412005 - ELABORACION DE PRODUCTOS LACTEOS' },
  { value: '412006', label: '412006 - ELABORACION DE PRODUCTOS DE MOLINERIA' },
  { value: '412007', label: '412007 - ELABORACION DE ALMIDONES Y DERIVADOS' },
  { value: '412008', label: '412008 - ELABORACION DE ALIMENTOS PARA ANIMALES' },
  { value: '412009', label: '412009 - ELABORACION DE PRODUCTOS PARA PANADERIA' },
  { value: '412010', label: '412010 - ELABORACION DE AZUCAR Y MELAZAS' },
  { value: '412011', label: '412011 - ELABORACION DE CACAO, CHOCOLATE Y CONFITERIA' },
  { value: '412012', label: '412012 - ELABORACION DE PASTAS  Y PRODUCTOS FARINACEOS' },
  { value: '412013', label: '412013 - ELABORACION DE PRODUCTOS DE CAFE' },
  { value: '412014', label: '412014 - ELABORACION DE OTROS PRODUCTOS ALIMENTICIOS' },
  { value: '412015', label: '412015 - ELABORACION DE BEBIDAS ALCOHOLICAS Y ALCOHOL ETILICO' },
  { value: '412016', label: '412016 - ELABORACION DE VINOS' },
  { value: '412017', label: '412017 - ELABORACION DE BEBIDAS MALTEADAS Y DE MALTA' },
  { value: '412018', label: '412018 - ELABORACION DE BEBIDAS NO ALCOHOLICAS' },
  { value: '412019', label: '412019 - ELABORACION DE PRODUCTOS DE TABACO' },
  { value: '412020', label: '412020 - PREPARACION E HILATURA DE FIBRAS TEXTILES Y TEJEDURIA' },
  { value: '412021', label: '412021 - ACABADO DE PRODUCTOS TEXTILES' },
  { value: '412022', label: '412022 - ELABORACION DE ARTICULOS DE MATERIALES TEXTILES' },
  { value: '412023', label: '412023 - ELABORACION DE TAPICES Y ALFOMBRAS' },
  { value: '412024', label: '412024 - ELABORACION DE CUERDAS, CORDELES, BRAMANTES Y REDES' },
  { value: '412025', label: '412025 - ELABORACION DE OTROS PRODUCTOS TEXTILES' },
  { value: '412026', label: '412026 - ELABORACION DE TEJIDOS' },
  { value: '412027', label: '412027 - ELABORACION DE PRENDAS DE VESTIR' },
  { value: '412028', label: '412028 - PREPARACION, ADOBO Y TEÑIDO DE PIELES' },
  { value: '412029', label: '412029 - CURTIDO, ADOBO O PREPARACION DE CUERO' },
  { value: '412030', label: '412030 - ELABORACION DE MALETAS, BOLSOS Y SIMILARES' },
  { value: '412031', label: '412031 - ELABORACION DE CALZADO' },
  { value: '412032', label: '412032 - PRODUCCION DE MADERA, ARTICULOS DE MADERA Y CORCHO' },
  { value: '412033', label: '412033 - ELABORACION DE PASTA Y PRODUCTOS DE MADERA, PAPEL Y CARTON' },
  { value: '412034', label: '412034 - EDICIONES Y PUBLICACIONES' },
  { value: '412035', label: '412035 - IMPRESION' },
  { value: '412036', label: '412036 - SERVICIOS RELACIONADOS CON LA EDICION Y LA IMPRESION' },
  { value: '412037', label: '412037 - REPRODUCCION DE GRABACIONES' },
  { value: '412038', label: '412038 - ELABORACION DE PRODUCTOS DE HORNO DE COQUE' },
  { value: '412039', label: '412039 - ELABORACION DE PRODUCTOS DE LA REFINACION DE PETROLEO' },
  { value: '412040', label: '412040 - ELABORACION DE SUSTANCIAS QUIMICAS BASICAS' },
  { value: '412041', label: '412041 - ELABORACION DE ABONOS Y COMPUESTOS DE NITROGENO' },
  { value: '412042', label: '412042 - ELABORACION DE PLASTICO Y CAUCHO SINTETICO' },
  { value: '412043', label: '412043 - ELABORACION DE PRODUCTOS QUIMICOS DE USO AGROPECUARIO' },
  { value: '412044', label: '412044 - ELABORACION DE PINTURAS, TINTAS Y MASILLAS' },
  { value: '412045', label: '412045 - ELABORACION DE PRODUCTOS FARMACEUTICOS Y BOTANICOS' },
  { value: '412046', label: '412046 - ELABORACION DE JABONES, DETERGENTES Y PREPARADOS DE TOCADOR' },
  { value: '412047', label: '412047 - ELABORACION DE OTROS PRODUCTOS QUIMICOS' },
  { value: '412048', label: '412048 - ELABORACION DE FIBRAS' },
  { value: '412049', label: '412049 - ELABORACION DE OTROS PRODUCTOS DE CAUCHO' },
  { value: '412050', label: '412050 - ELABORACION DE PRODUCTOS DE PLASTICO' },
  { value: '412051', label: '412051 - ELABORACION DE VIDRIO Y PRODUCTOS DE VIDRIO' },
  { value: '412052', label: '412052 - ELABORACION DE PRODUCTOS DE CERAMICA, LOZA, PIEDRA, ARCILLA Y PORCELANA' },
  { value: '412053', label: '412053 - ELABORACION DE CEMENTO, CAL Y YESO' },
  { value: '412054', label: '412054 - ELABORACION DE ARTICULOS DE HORMIGON, CEMENTO Y YESO' },
  { value: '412055', label: '412055 - CORTE, TALLADO Y ACABADO DE LA PIEDRA' },
  { value: '412056', label: '412056 - ELABORACION DE OTROS PRODUCTOS MINERALES NO METALICOS' },
  { value: '412057', label: '412057 - INDUSTRIAS BASICAS Y FUNDICION DE HIERRO Y ACERO' },
  { value: '412058', label: '412058 - PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y DE METALES NO FERROSOS' },
  { value: '412059', label: '412059 - FUNDICION DE METALES NO FERROSOS' },
  { value: '412060', label: '412060 - FABRICACION DE PRODUCTOS METALICOS PARA USO ESTRUCTURAL' },
  { value: '412061', label: '412061 - FORJA, PRENSADO, ESTAMPADO, LAMINADO DE METAL Y PULVIMETALURGIA' },
  { value: '412062', label: '412062 - REVESTIMIENTO DE METALES Y OBRAS DE INGENIERIA MECANICA' },
  { value: '412063', label: '412063 - FABRICACION DE ARTICULOS DE FERRETERIA' },
  { value: '412064', label: '412064 - ELABORACION DE OTROS PRODUCTOS DE METAL' },
  { value: '412065', label: '412065 - FABRICACION DE MAQUINARIA Y EQUIPO' },
  { value: '412066', label: '412066 - FABRICACION DE EQUIPOS DE ELEVACION Y MANIPULACION' },
  { value: '412067', label: '412067 - ELABORACION DE APARATOS DE USO DOMESTICO' },
  { value: '412068', label: '412068 - ELABORACION DE EQUIPO DE OFICINA' },
  { value: '412069', label: '412069 - ELABORACION DE PILAS Y BATERIAS PRIMARIAS' },
  { value: '412070', label: '412070 - ELABORACION DE EQUIPO DE ILUMINACION' },
  { value: '412071', label: '412071 - ELABORACION DE OTROS TIPOS DE EQUIPO ELECTRICO' },
  { value: '412072', label: '412072 - FABRICACION DE EQUIPOS DE RADIO, TELEVISION Y COMUNICACIONES' },
  { value: '412073', label: '412073 - FABRICACION DE APARATOS E INSTRUMENTOS MEDICOS' },
  { value: '412074', label: '412074 - FABRICACION DE INSTRUMENTOS DE MEDICION Y CONTROL' },
  { value: '412075', label: '412075 - FABRICACION DE INSTRUMENTOS DE OPTICA Y EQUIPO FOTOGRAFICO' },
  { value: '412076', label: '412076 - FABRICACION DE RELOJES' },
  { value: '412077', label: '412077 - FABRICACION DE VEHICULOS AUTOMOTORES' },
  { value: '412078', label: '412078 - FABRICACION DE CARROCERIAS PARA AUTOMOTORES' },
  { value: '412079', label: '412079 - FABRICACION DE PARTES PIEZAS Y ACCESORIOS PARA AUTOMOTORES' },
  { value: '412080', label: '412080 - FABRICACION Y REPARACION DE BUQUES Y OTRAS EMBARCACIONES' },
  { value: '412081', label: '412081 - FABRICACION DE LOCOMOTORAS Y MATERIAL RODANTE PARA FERROCARRILES' },
  { value: '412082', label: '412082 - FABRICACION DE AERONAVES' },
  { value: '412083', label: '412083 - FABRICACION DE MOTOCICLETAS' },
  { value: '412084', label: '412084 - FABRICACION DE BICICLETAS Y SILLAS DE RUEDAS' },
  { value: '412085', label: '412085 - FABRICACION DE OTROS TIPOS DE TRANSPORTE' },
  { value: '412086', label: '412086 - FABRICACION DE MUEBLES' },
  { value: '412087', label: '412087 - FABRICACION DE JOYAS Y ARTICULOS CONEXOS' },
  { value: '412088', label: '412088 - FABRICACION DE INSTRUMENTOS DE MUSICA' },
  { value: '412089', label: '412089 - FABRICACION DE ARTICULOS Y EQUIPO PARA DEPORTE' },
  { value: '412090', label: '412090 - FABRICACION DE JUEGOS Y JUGUETES' },
  { value: '412091', label: '412091 - RECICLAMIENTO DE DESPERDICIOS' },
  { value: '412095', label: '412095 - PRODUCTOS DE OTRAS INDUSTRIAS MANUFACTURERAS' },
  { value: '412099', label: '412099 - AJUSTES POR INFLACION' },
  { value: '4125', label: '4125 - SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: '412505', label: '412505 - GENERACION, CAPTACION Y DISTRIBUCION DE ENERGIA ELECTRICA' },
  { value: '412510', label: '412510 - FABRICACION DE GAS Y DISTRIBUCION DE COMBUSTIBLES GASEOSOS' },
  { value: '412515', label: '412515 - CAPTACION, DEPURACION Y DISTRIBUCION DE AGUA' },
  { value: '412595', label: '412595 - ACTIVIDADES CONEXAS' },
  { value: '412599', label: '412599 - AJUSTES POR INFLACION' },
  { value: '4130', label: '4130 - CONSTRUCCION' },
  { value: '413005', label: '413005 - PREPARACION DE TERRENOS' },
  { value: '413010', label: '413010 - CONSTRUCCION DE EDIFICIOS Y OBRAS DE INGENIERIA CIVIL' },
  { value: '413015', label: '413015 - ACONDICIONAMIENTO DE EDIFICIOS' },
  { value: '413020', label: '413020 - TERMINACION DE EDIFICACIONES' },
  { value: '413025', label: '413025 - ALQUILER DE EQUIPO CON OPERARIOS' },
  { value: '413095', label: '413095 - ACTIVIDADES CONEXAS' },
  { value: '413099', label: '413099 - AJUSTES POR INFLACION' },
  { value: '4135', label: '4135 - COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: '413502', label: '413502 - VENTA DE VEHICULOS AUTOMOTORES' },
  { value: '413504', label: '413504 - MANTENIMIENTO, REPARACION Y LAVADO DE VEHICULOS AUTOMOTORES' },
  { value: '413506', label: '413506 - VENTA DE PARTES, PIEZAS Y ACCESORIOS DE VEHICULOS AUTOMOTORES' },
  { value: '413508', label: '413508 - VENTA DE COMBUSTIBLES SOLIDOS, LIQUIDOS, GASEOSOS' },
  { value: '413510', label: '413510 - VENTA DE LUBRICANTES, ADITIVOS, LLANTAS Y LUJOS PARA AUTOMOTORES' },
  { value: '413512', label: '413512 - VENTA A CAMBIO DE RETRIBUCION O POR CONTRATA' },
  { value: '413514', label: '413514 - VENTA DE INSUMOS, MATERIAS PRIMAS AGROPECUARIAS Y FLORES' },
  { value: '413516', label: '413516 - VENTA DE OTROS INSUMOS Y MATERIAS PRIMAS NO AGROPECUARIAS' },
  { value: '413518', label: '413518 - VENTA DE ANIMALES VIVOS Y CUEROS' },
  { value: '413520', label: '413520 - VENTA DE PRODUCTOS EN ALMACENES NO ESPECIALIZADOS' },
  { value: '413522', label: '413522 - VENTA DE PRODUCTOS AGROPECUARIOS' },
  { value: '413524', label: '413524 - VENTA DE PRODUCTOS TEXTILES, DE VESTIR, DE CUERO Y CALZADO' },
  { value: '413526', label: '413526 - VENTA DE PAPEL Y CARTON' },
  { value: '413528', label: '413528 - VENTA DE LIBROS, REVISTAS, ELEMENTOS DE PAPELERIA, UTILES Y TEXTOS ESCOLARES' },
  { value: '413530', label: '413530 - VENTA DE JUEGOS, JUGUETES Y ARTICULOS DEPORTIVOS' },
  { value: '413532', label: '413532 - VENTA DE INSTRUMENTOS QUIRURGICOS Y ORTOPEDICOS' },
  { value: '413534', label: '413534 - VENTA DE ARTICULOS EN RELOJERIAS Y JOYERIAS' },
  { value: '413536', label: '413536 - VENTA DE ELECTRODOMESTICOS Y MUEBLES' },
  { value: '413538', label: '413538 - VENTA DE PRODUCTOS DE ASEO, FARMACEUTICOS, MEDICINALES, Y ARTICULOS DE TOCADOR' },
  { value: '413540', label: '413540 - VENTA DE CUBIERTOS, VAJILLAS, CRISTALERIA, PORCELANAS, CERAMICAS Y OTROS ARTICULOS DE USO DOMESTICO' },
  { value: '413542', label: '413542 - VENTA DE MATERIALES DE CONSTRUCCION, FONTANERIA Y CALEFACCION' },
  { value: '413544', label: '413544 - VENTA DE PINTURAS Y LACAS' },
  { value: '413546', label: '413546 - VENTA DE PRODUCTOS DE VIDRIOS Y MARQUETERIA' },
  { value: '413548', label: '413548 - VENTA DE HERRAMIENTAS Y ARTICULOS DE FERRETERIA' },
  { value: '413550', label: '413550 - VENTA DE QUIMICOS' },
  { value: '413552', label: '413552 - VENTA DE PRODUCTOS INTERMEDIOS, DESPERDICIOS Y DESECHOS' },
  { value: '413554', label: '413554 - VENTA DE MAQUINARIA, EQUIPO DE OFICINA Y PROGRAMAS DE COMPUTADOR' },
  { value: '413556', label: '413556 - VENTA DE ARTICULOS EN CACHARRERIAS Y MISCELANEAS' },
  { value: '413558', label: '413558 - VENTA DE INSTRUMENTOS MUSICALES' },
  { value: '413560', label: '413560 - VENTA DE ARTICULOS EN CASAS DE EMPEÑO Y PRENDERIAS' },
  { value: '413562', label: '413562 - VENTA DE EQUIPO FOTOGRAFICO' },
  { value: '413564', label: '413564 - VENTA DE EQUIPO OPTICO Y DE PRECISION' },
  { value: '413566', label: '413566 - VENTA DE EMPAQUES' },
  { value: '413568', label: '413568 - VENTA DE EQUIPO PROFESIONAL Y CIENTIFICO' },
  { value: '413570', label: '413570 - VENTA DE LOTERIAS, RIFAS, CHANCE, APUESTAS Y SIMILARES' },
  { value: '413572', label: '413572 - REPARACION DE EFECTOS PERSONALES Y ELECTRODOMESTICOS' },
  { value: '413595', label: '413595 - VENTA DE OTROS PRODUCTOS' },
  { value: '413599', label: '413599 - AJUSTES POR INFLACION' },
  { value: '4140', label: '4140 - HOTELES Y RESTAURANTES' },
  { value: '414005', label: '414005 - HOTELERIA' },
  { value: '414010', label: '414010 - CAMPAMENTO Y OTROS TIPOS DE HOSPEDAJE' },
  { value: '414015', label: '414015 - RESTAURANTES' },
  { value: '414020', label: '414020 - BARES Y CANTINAS' },
  { value: '414095', label: '414095 - ACTIVIDADES CONEXAS' },
  { value: '414099', label: '414099 - AJUSTES POR INFLACION' },
  { value: '4145', label: '4145 - TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: '414505', label: '414505 - SERVICIO DE TRANSPORTE POR CARRETERA' },
  { value: '414510', label: '414510 - SERVICIO DE TRANSPORTE POR VIA FERREA' },
  { value: '414515', label: '414515 - SERVICIO DE TRANSPORTE POR VIA ACUATICA' },
  { value: '414520', label: '414520 - SERVICIO DE TRANSPORTE POR VIA AEREA' },
  { value: '414525', label: '414525 - SERVICIO DE TRANSPORTE POR TUBERIAS' },
  { value: '414530', label: '414530 - MANIPULACION DE CARGA' },
  { value: '414535', label: '414535 - ALMACENAMIENTO Y DEPOSITO' },
  { value: '414540', label: '414540 - SERVICIOS COMPLEMENTARIOS PARA EL TRANSPORTE' },
  { value: '414545', label: '414545 - AGENCIAS DE VIAJE' },
  { value: '414550', label: '414550 - OTRAS AGENCIAS DE TRANSPORTE' },
  { value: '414555', label: '414555 - SERVICIO POSTAL Y DE CORREO' },
  { value: '414560', label: '414560 - SERVICIO TELEFONICO' },
  { value: '414565', label: '414565 - SERVICIO DE TELEGRAFO' },
  { value: '414570', label: '414570 - SERVICIO DE TRANSMISION DE DATOS' },
  { value: '414575', label: '414575 - SERVICIO DE RADIO Y TELEVISION POR CABLE' },
  { value: '414580', label: '414580 - TRANSMISION DE SONIDO E IMAGENES POR CONTRATO' },
  { value: '414595', label: '414595 - ACTIVIDADES CONEXAS' },
  { value: '414599', label: '414599 - AJUSTES POR INFLACION' },
  { value: '4150', label: '4150 - ACTIVIDAD FINANCIERA' },
  { value: '415005', label: '415005 - VENTA DE INVERSIONES' },
  { value: '415010', label: '415010 - DIVIDENDOS DE SOCIEDADES ANONIMAS Y/O ASIMILADAS' },
  { value: '415015', label: '415015 - PARTICIPACIONES DE SOCIEDADES LIMITADAS Y/O ASIMILADAS' },
  { value: '415020', label: '415020 - INTERESES' },
  { value: '415025', label: '415025 - REAJUSTE MONETARIO - UPAC' },
  { value: '415030', label: '415030 - COMISIONES' },
  { value: '415035', label: '415035 - OPERACIONES DE DESCUENTO' },
  { value: '415040', label: '415040 - CUOTAS DE INSCRIPCION - CONSORCIOS' },
  { value: '415045', label: '415045 - CUOTAS DE ADMINISTRACION - CONSORCIOS' },
  { value: '415050', label: '415050 - REAJUSTE DEL SISTEMA - CONSORCIOS' },
  { value: '415055', label: '415055 - ELIMINACION DE SUSCRIPTORES - CONSORCIOS' },
  { value: '415060', label: '415060 - CUOTAS DE INGRESO O RETIRO - SOCIEDAD ADMINISTRADORA' },
  { value: '415065', label: '415065 - SERVICIOS A COMISIONISTAS' },
  { value: '415070', label: '415070 - INSCRIPCIONES Y CUOTAS' },
  { value: '415075', label: '415075 - RECUPERACION DE GARANTIAS' },
  { value: '415095', label: '415095 - ACTIVIDADES CONEXAS' },
  { value: '415099', label: '415099 - AJUSTES POR INFLACION' },
  { value: '4155', label: '4155 - ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: '415505', label: '415505 - ARRENDAMIENTOS DE BIENES INMUEBLES' },
  { value: '415510', label: '415510 - INMOBILIARIAS POR RETRIBUCION O CONTRATA' },
  { value: '415515', label: '415515 - ALQUILER EQUIPO DE TRANSPORTE' },
  { value: '415520', label: '415520 - ALQUILER MAQUINARIA Y EQUIPO' },
  { value: '415525', label: '415525 - ALQUILER DE EFECTOS PERSONALES Y ENSERES DOMESTICOS' },
  { value: '415530', label: '415530 - CONSULTORIA EN EQUIPO Y PROGRAMAS DE INFORMATICA' },
  { value: '415535', label: '415535 - PROCESAMIENTO DE DATOS' },
  { value: '415540', label: '415540 - MANTENIMIENTO Y REPARACION DE MAQUINARIA DE OFICINA' },
  { value: '415545', label: '415545 - INVESTIGACIONES CIENTIFICAS Y DE DESARROLLO' },
  { value: '415550', label: '415550 - ACTIVIDADES EMPRESARIALES DE CONSULTORIA' },
  { value: '415555', label: '415555 - PUBLICIDAD' },
  { value: '415560', label: '415560 - DOTACION DE PERSONAL' },
  { value: '415565', label: '415565 - INVESTIGACION Y SEGURIDAD' },
  { value: '415570', label: '415570 - LIMPIEZA DE INMUEBLES' },
  { value: '415575', label: '415575 - FOTOGRAFIA' },
  { value: '415580', label: '415580 - ENVASE Y EMPAQUE' },
  { value: '415585', label: '415585 - FOTOCOPIADO' },
  { value: '415590', label: '415590 - MANTENIMIENTO Y REPARACION DE MAQUINARIA Y EQUIPO' },
  { value: '415595', label: '415595 - ACTIVIDADES CONEXAS' },
  { value: '415599', label: '415599 - AJUSTES POR INFLACION' },
  { value: '4160', label: '4160 - ENSEÑANZA' },
  { value: '416005', label: '416005 - ACTIVIDADES RELACIONADAS CON LA EDUCACION' },
  { value: '416095', label: '416095 - ACTIVIDADES CONEXAS' },
  { value: '416099', label: '416099 - AJUSTES POR INFLACION' },
  { value: '4165', label: '4165 - SERVICIOS SOCIALES Y DE SALUD' },
  { value: '416505', label: '416505 - SERVICIO HOSPITALARIO' },
  { value: '416510', label: '416510 - SERVICIO MEDICO' },
  { value: '416515', label: '416515 - SERVICIO ODONTOLOGICO' },
  { value: '416520', label: '416520 - SERVICIO DE LABORATORIO' },
  { value: '416525', label: '416525 - ACTIVIDADES VETERINARIAS' },
  { value: '416530', label: '416530 - ACTIVIDADES DE SERVICIOS SOCIALES' },
  { value: '416595', label: '416595 - ACTIVIDADES CONEXAS' },
  { value: '416599', label: '416599 - AJUSTES POR INFLACION' },
  { value: '4170', label: '4170 - OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES Y PERSONALES' },
  { value: '417005', label: '417005 - ELIMINACION DE DESPERDICIOS Y AGUAS RESIDUALES' },
  { value: '417010', label: '417010 - ACTIVIDADES DE ASOCIACION' },
  { value: '417015', label: '417015 - PRODUCCION Y DISTRIBUCION DE FILMES Y VIDEOCINTAS' },
  { value: '417020', label: '417020 - EXHIBICION DE FILMES Y VIDEOCINTAS' },
  { value: '417025', label: '417025 - ACTIVIDAD DE RADIO Y TELEVISION' },
  { value: '417030', label: '417030 - ACTIVIDAD TEATRAL, MUSICAL Y ARTISTICA' },
  { value: '417035', label: '417035 - GRABACION Y PRODUCCION DE DISCOS' },
  { value: '417040', label: '417040 - ENTRETENIMIENTO Y ESPARCIMIENTO' },
  { value: '417045', label: '417045 - AGENCIAS DE NOTICIAS' },
  { value: '417050', label: '417050 - LAVANDERIAS Y SIMILARES' },
  { value: '417055', label: '417055 - PELUQUERIAS Y SIMILARES' },
  { value: '417060', label: '417060 - SERVICIOS FUNERARIOS' },
  { value: '417065', label: '417065 - ZONAS FRANCAS' },
  { value: '417095', label: '417095 - ACTIVIDADES CONEXAS' },
  { value: '417099', label: '417099 - AJUSTES POR INFLACION' },
  { value: '4175', label: '4175 - DEVOLUCIONES, REBAJAS Y DESCUENTOS EN VENTAS (DB)' },
  { value: '417599', label: '417599 - AJUSTES POR INFLACION' },
  { value: '42', label: '42 - NO OPERACIONALES' },
  { value: '4205', label: '4205 - OTRAS VENTAS' },
  { value: '420505', label: '420505 - MATERIA PRIMA' },
  { value: '420510', label: '420510 - MATERIAL DE DESECHO' },
  { value: '420515', label: '420515 - MATERIALES VARIOS' },
  { value: '420520', label: '420520 - PRODUCTOS DE DIVERSIFICACION' },
  { value: '420525', label: '420525 - EXCEDENTES DE EXPORTACION' },
  { value: '420530', label: '420530 - ENVASES Y EMPAQUES' },
  { value: '420535', label: '420535 - PRODUCTOS AGRICOLAS' },
  { value: '420540', label: '420540 - DE PROPAGANDA' },
  { value: '420545', label: '420545 - PRODUCTOS EN REMATE' },
  { value: '420550', label: '420550 - COMBUSTIBLES Y LUBRICANTES' },
  { value: '420599', label: '420599 - AJUSTES POR INFLACION' },
  { value: '4210', label: '4210 - FINANCIEROS' },
  { value: '421005', label: '421005 - INTERESES' },
  { value: '421010', label: '421010 - REAJUSTE MONETARIO - UPAC' },
  { value: '421015', label: '421015 - DESCUENTOS AMORTIZADOS' },
  { value: '421020', label: '421020 - DIFERENCIA EN CAMBIO' },
  { value: '421025', label: '421025 - FINANCIACION VEHICULOS' },
  { value: '421030', label: '421030 - FINANCIACION SISTEMAS DE VIAJES' },
  { value: '421035', label: '421035 - ACEPTACIONES BANCARIAS' },
  { value: '421040', label: '421040 - DESCUENTOS COMERCIALES CONDICIONADOS' },
  { value: '421045', label: '421045 - DESCUENTOS BANCARIOS' },
  { value: '421050', label: '421050 - COMISIONES CHEQUES DE OTRAS PLAZAS' },
  { value: '421055', label: '421055 - MULTAS Y RECARGOS' },
  { value: '421060', label: '421060 - SANCIONES CHEQUES DEVUELTOS' },
  { value: '421095', label: '421095 - OTROS' },
  { value: '421099', label: '421099 - AJUSTES POR INFLACION' },
  { value: '4215', label: '4215 - DIVIDENDOS Y PARTICIPACIONES' },
  { value: '421505', label: '421505 - DE SOCIEDADES ANONIMAS Y/O ASIMILADAS' },
  { value: '421510', label: '421510 - DE SOCIEDADES LIMITADAS Y/O ASIMILADAS' },
  { value: '421599', label: '421599 - AJUSTES POR INFLACION' },
  { value: '4220', label: '4220 - ARRENDAMIENTOS' },
  { value: '422005', label: '422005 - TERRENOS' },
  { value: '422010', label: '422010 - CONSTRUCCIONES Y EDIFICIOS' },
  { value: '422015', label: '422015 - MAQUINARIA Y EQUIPO' },
  { value: '422020', label: '422020 - EQUIPO DE OFICINA' },
  { value: '422025', label: '422025 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '422030', label: '422030 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '422035', label: '422035 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '422040', label: '422040 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '422045', label: '422045 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '422050', label: '422050 - FLOTA Y EQUIPO AEREO' },
  { value: '422055', label: '422055 - FLOTA Y EQUIPO FERREO' },
  { value: '422060', label: '422060 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '422062', label: '422062 - ENVASES Y EMPAQUES' },
  { value: '422065', label: '422065 - PLANTACIONES AGRICOLAS  Y FORESTALES' },
  { value: '422070', label: '422070 - AERODROMOS' },
  { value: '422075', label: '422075 - SEMOVIENTES' },
  { value: '422099', label: '422099 - AJUSTES POR INFLACION' },
  { value: '4225', label: '4225 - COMISIONES' },
  { value: '422505', label: '422505 - SOBRE INVERSIONES' },
  { value: '422510', label: '422510 - DE CONCESIONARIOS' },
  { value: '422515', label: '422515 - DE ACTIVIDADES FINANCIERAS' },
  { value: '422520', label: '422520 - POR VENTA DE SERVICIOS DE TALLER' },
  { value: '422525', label: '422525 - POR VENTA DE SEGUROS' },
  { value: '422530', label: '422530 - POR INGRESOS PARA TERCEROS' },
  { value: '422535', label: '422535 - POR DISTRIBUCION DE PELICULAS' },
  { value: '422540', label: '422540 - DERECHOS DE AUTOR' },
  { value: '422545', label: '422545 - DERECHOS DE PROGRAMACION' },
  { value: '422599', label: '422599 - AJUSTES POR INFLACION' },
  { value: '4230', label: '4230 - HONORARIOS' },
  { value: '423005', label: '423005 - ASESORIAS' },
  { value: '423010', label: '423010 - ASISTENCIA TECNICA' },
  { value: '423015', label: '423015 - ADMINISTRACION DE VINCULADAS' },
  { value: '423099', label: '423099 - AJUSTES POR INFLACION' },
  { value: '4235', label: '4235 - SERVICIOS' },
  { value: '423505', label: '423505 - DE BASCULA' },
  { value: '423510', label: '423510 - DE TRANSPORTE' },
  { value: '423515', label: '423515 - DE PRENSA' },
  { value: '423520', label: '423520 - ADMINISTRATIVOS' },
  { value: '423525', label: '423525 - TECNICOS' },
  { value: '423530', label: '423530 - DE COMPUTACION' },
  { value: '423535', label: '423535 - DE TELEFAX' },
  { value: '423540', label: '423540 - TALLER DE VEHICULOS' },
  { value: '423545', label: '423545 - DE RECEPCION DE AERONAVES' },
  { value: '423550', label: '423550 - DE TRANSPORTE PROGRAMA GAS NATURAL' },
  { value: '423555', label: '423555 - POR CONTRATOS' },
  { value: '423560', label: '423560 - DE TRILLLA' },
  { value: '423565', label: '423565 - DE MANTENIMIENTO' },
  { value: '423570', label: '423570 - AL PERSONAL' },
  { value: '423575', label: '423575 - DE CASINO' },
  { value: '423580', label: '423580 - FLETES' },
  { value: '423585', label: '423585 - ENTRE COMPAÑIAS' },
  { value: '423595', label: '423595 - OTROS' },
  { value: '423599', label: '423599 - AJUSTES POR INFLACION' },
  { value: '4240', label: '4240 - UTILIDAD EN VENTA DE INVERSIONES' },
  { value: '424005', label: '424005 - ACCIONES' },
  { value: '424010', label: '424010 - CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '424015', label: '424015 - BONOS' },
  { value: '424020', label: '424020 - CEDULAS' },
  { value: '424025', label: '424025 - CERTIFICADOS' },
  { value: '424030', label: '424030 - PAPELES COMERCIALES' },
  { value: '424035', label: '424035 - TITULOS' },
  { value: '424045', label: '424045 - DERECHOS FIDUCIARIOS' },
  { value: '424050', label: '424050 - OBLIGATORIAS' },
  { value: '424095', label: '424095 - OTRAS' },
  { value: '424099', label: '424099 - AJUSTES POR INFLACION' },
  { value: '4245', label: '4245 - UTILIDAD EN VENTA DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: '424504', label: '424504 - TERRENOS' },
  { value: '424506', label: '424506 - MATERIALES INDUSTRIA PETROLERA' },
  { value: '424508', label: '424508 - CONSTRUCCIONES EN CURSO' },
  { value: '424512', label: '424512 - MAQUINARIA EN MONTAJE' },
  { value: '424516', label: '424516 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '424520', label: '424520 - MAQUINARIA Y EQUIPO' },
  { value: '424524', label: '424524 - EQUIPO DE OFICINA' },
  { value: '424528', label: '424528 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '424532', label: '424532 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '424536', label: '424536 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '424540', label: '424540 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '424544', label: '424544 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '424548', label: '424548 - FLOTA Y EQUIPO AEREO' },
  { value: '424552', label: '424552 - FLOTA Y EQUIPO FERREO' },
  { value: '424556', label: '424556 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '424560', label: '424560 - ARMAMENTO DE VIGILANCIA' },
  { value: '424562', label: '424562 - ENVASES Y EMPAQUES' },
  { value: '424564', label: '424564 - PLANTACIONES AGRICOLAS  Y FORESTALES' },
  { value: '424568', label: '424568 - VIAS DE COMUNICACION' },
  { value: '424572', label: '424572 - MINAS Y CANTERAS' },
  { value: '424580', label: '424580 - POZOS ARTESIANOS' },
  { value: '424584', label: '424584 - YACIMIENTOS' },
  { value: '424588', label: '424588 - SEMOVIENTES' },
  { value: '424599', label: '424599 - AJUSTES POR INFLACION' },
  { value: '4248', label: '4248 - UTILIDAD EN VENTA DE OTROS BIENES' },
  { value: '424805', label: '424805 - INTANGIBLES' },
  { value: '424810', label: '424810 - OTROS ACTIVOS' },
  { value: '424899', label: '424899 - AJUSTES POR INFLACION' },
  { value: '4250', label: '4250 - RECUPERACIONES' },
  { value: '425005', label: '425005 - DEUDAS MALAS' },
  { value: '425010', label: '425010 - SEGUROS' },
  { value: '425015', label: '425015 - RECLAMOS' },
  { value: '425020', label: '425020 - REINTEGRO POR PERSONAL EN COMISION' },
  { value: '425025', label: '425025 - REINTEGRO GARANTIAS' },
  { value: '425030', label: '425030 - DESCUENTOS CONCEDIDOS' },
  { value: '425035', label: '425035 - REINTEGRO PROVISIONES' },
  { value: '425040', label: '425040 - GASTOS BANCARIOS' },
  { value: '425045', label: '425045 - DE DEPRECIACION' },
  { value: '425050', label: '425050 - REINTEGRO DE OTROS COSTOS Y GASTOS' },
  { value: '425099', label: '425099 - AJUSTES POR INFLACION' },
  { value: '4255', label: '4255 - INDEMNIZACIONES' },
  { value: '425505', label: '425505 - POR SINIESTRO' },
  { value: '425510', label: '425510 - POR SUMINISTROS' },
  { value: '425515', label: '425515 - LUCRO CESANTE COMPAÑIAS DE SEGUROS' },
  { value: '425520', label: '425520 - DAÑO EMERGENTE COMPAÑIAS DE SEGUROS' },
  { value: '425525', label: '425525 - POR PERDIDA DE MERCANCIA' },
  { value: '425530', label: '425530 - POR INCUMPLIMIENTO DE CONTRATOS' },
  { value: '425535', label: '425535 - DE TERCEROS' },
  { value: '425540', label: '425540 - POR INCAPACIDADES I.S.S.' },
  { value: '425595', label: '425595 - OTRAS' },
  { value: '425599', label: '425599 - AJUSTES POR INFLACION' },
  { value: '4260', label: '4260 - PARTICIPACIONES EN CONCESIONES' },
  { value: '426099', label: '426099 - AJUSTES POR INFLACION' },
  { value: '4265', label: '4265 - INGRESOS DE EJERCICIOS ANTERIORES' },
  { value: '426599', label: '426599 - AJUSTES POR INFLACION' },
  { value: '4275', label: '4275 - DEVOLUCIONES, REBAJAS Y DESCUENTOS EN OTRAS VENTAS (DB)' },
  { value: '427599', label: '427599 - AJUSTES POR INFLACION' },
  { value: '4295', label: '4295 - DIVERSOS' },
  { value: '429503', label: '429503 - CERT' },
  { value: '429505', label: '429505 - APROVECHAMIENTOS' },
  { value: '429507', label: '429507 - AUXILIOS' },
  { value: '429509', label: '429509 - DONACIONES' },
  { value: '429511', label: '429511 - INGRESOS POR INVESTIGACION Y DESARROLLO' },
  { value: '429513', label: '429513 - POR TRABAJOS EJECUTADOS' },
  { value: '429515', label: '429515 - REGALIAS' },
  { value: '429517', label: '429517 - DERIVADOS DE LAS EXPORTACIONES' },
  { value: '429519', label: '429519 - OTROS INGRESOS DE EXPLOTACION' },
  { value: '429521', label: '429521 - DE LA ACTIVIDAD GANADERA' },
  { value: '429525', label: '429525 - DERECHOS Y LICITACIONES' },
  { value: '429530', label: '429530 - INGRESOS POR ELEMENTOS PERDIDOS' },
  { value: '429533', label: '429533 - MULTAS Y RECARGOS' },
  { value: '429535', label: '429535 - PREAVISOS DESCONTADOS' },
  { value: '429537', label: '429537 - RECLAMOS' },
  { value: '429540', label: '429540 - RECOBRO DE DAÑOS' },
  { value: '429543', label: '429543 - PREMIOS' },
  { value: '429545', label: '429545 - BONIFICACIONES' },
  { value: '429547', label: '429547 - PRODUCTOS DESCONTADOS' },
  { value: '429549', label: '429549 - RECONOCIMIENTOS I.S.S.' },
  { value: '429551', label: '429551 - EXCEDENTES' },
  { value: '429553', label: '429553 - SOBRANTES DE CAJA MENOR' },
  { value: '429555', label: '429555 - SOBRANTES EN LIQUIDACION FLETES' },
  { value: '429557', label: '429557 - SUBSIDIOS ESTATALES' },
  { value: '429559', label: '429559 - CAPACITACION DISTRIBUIDORES' },
  { value: '429561', label: '429561 - DE ESCRITURACION' },
  { value: '429563', label: '429563 - REGISTRO PROMESAS DE VENTA' },
  { value: '429567', label: '429567 - UTILES, PAPELERIA Y FOTOCOPIAS' },
  { value: '429571', label: '429571 - RESULTADOS MATRICULAS Y TRASPASOS' },
  { value: '429573', label: '429573 - DECORACIONES' },
  { value: '429575', label: '429575 - MANEJO DE CARGA' },
  { value: '429579', label: '429579 - HISTORIA CLINICA' },
  { value: '429581', label: '429581 - AJUSTE AL PESO' },
  { value: '429583', label: '429583 - LLAMADAS TELEFONICAS' },
  { value: '429599', label: '429599 - AJUSTES POR INFLACION' },
  { value: '47', label: '47 - AJUSTES POR INFLACION' },
  { value: '4705', label: '4705 - CORRECCION MONETARIA' },
  { value: '470505', label: '470505 - INVERSIONES (CR)' },
  { value: '470510', label: '470510 - INVENTARIOS (CR)' },
  { value: '470515', label: '470515 - PROPIEDADES, PLANTA Y EQUIPO (CR)' },
  { value: '470520', label: '470520 - INTANGIBLES (CR)' },
  { value: '470525', label: '470525 - ACTIVOS DIFERIDOS' },
  { value: '470530', label: '470530 - OTROS ACTIVOS (CR)' },
  { value: '470535', label: '470535 - PASIVOS SUJETOS DE AJUSTE' },
  { value: '470540', label: '470540 - PATRIMONIO' },
  { value: '470545', label: '470545 - DEPRECIACION ACUMULADA (DB)' },
  { value: '470550', label: '470550 - DEPRECIACION DIFERIDA (CR)' },
  { value: '470555', label: '470555 - AGOTAMIENTO ACUMULADO (DB)' },
  { value: '470560', label: '470560 - AMORTIZACION ACUMULADA (DB)' },
  { value: '470565', label: '470565 - INGRESOS OPERACIONALES (DB)' },
  { value: '470570', label: '470570 - INGRESOS NO OPERACIONALES (DB)' },
  { value: '470575', label: '470575 - GASTOS OPERACIONALES DE ADMINISTRACION (CR)' },
  { value: '470580', label: '470580 - GASTOS OPERACIONALES DE VENTAS (CR)' },
  { value: '470585', label: '470585 - GASTOS NO OPERACIONALES (CR)' },
  { value: '470590', label: '470590 - COMPRAS (CR)' },
  { value: '470592', label: '470592 - COSTO DE VENTAS (CR)' },
  { value: '470594', label: '470594 - COSTOS DE PRODUCCION O DE OPERACION (DB)' },
  { value: '5', label: '5 - GASTOS' },
  { value: '51', label: '51 - OPERACIONALES DE ADMINISTRACION' },
  { value: '5105', label: '5105 - GASTOS DE PERSONAL' },
  { value: '510503', label: '510503 - SALARIO INTEGRAL' },
  { value: '510506', label: '510506 - SUELDOS' },
  { value: '510512', label: '510512 - JORNALES' },
  { value: '510515', label: '510515 - HORAS EXTRAS Y RECARGOS' },
  { value: '510518', label: '510518 - COMISIONES' },
  { value: '510521', label: '510521 - VIATICOS' },
  { value: '510524', label: '510524 - INCAPACIDADES' },
  { value: '510527', label: '510527 - AUXILIO DE TRANSPORTE' },
  { value: '510530', label: '510530 - CESANTIAS' },
  { value: '510533', label: '510533 - INTERESES SOBRE CESANTIAS' },
  { value: '510536', label: '510536 - PRIMA DE SERVICIOS' },
  { value: '510539', label: '510539 - VACACIONES' },
  { value: '510542', label: '510542 - PRIMAS EXTRALEGALES' },
  { value: '510545', label: '510545 - AUXILIOS' },
  { value: '510548', label: '510548 - BONIFICACIONES' },
  { value: '510551', label: '510551 - DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: '510554', label: '510554 - SEGUROS' },
  { value: '510557', label: '510557 - CUOTAS PARTES PENSIONES DE JUBILACION' },
  { value: '510558', label: '510558 - AMORTIZACION CALCULO ACTUARIAL PENSIONES DE JUBILACION' },
  { value: '510559', label: '510559 - PENSIONES DE JUBILACION' },
  { value: '510560', label: '510560 - INDEMNIZACIONES LABORALES' },
  { value: '510563', label: '510563 - CAPACITACION AL PERSONAL' },
  { value: '510566', label: '510566 - GASTOS DEPORTIVOS Y DE RECREACION' },
  { value: '510569', label: '510569 - APORTES AL I.S.S' },
  { value: '510572', label: '510572 - APORTES CAJAS DE COMPENSACION FAMILIAR' },
  { value: '510575', label: '510575 - APORTES I.C.B.F.' },
  { value: '510578', label: '510578 - SENA' },
  { value: '510581', label: '510581 - APORTES SINDICALES' },
  { value: '510584', label: '510584 - GASTOS MEDICOS Y DROGAS' },
  { value: '510595', label: '510595 - OTROS' },
  { value: '510599', label: '510599 - AJUSTES POR INFLACION' },
  { value: '5110', label: '5110 - HONORARIOS' },
  { value: '511005', label: '511005 - JUNTA DIRECTIVA' },
  { value: '511010', label: '511010 - REVISORIA FISCAL' },
  { value: '511015', label: '511015 - AUDITORIA EXTERNA' },
  { value: '511020', label: '511020 - AVALUOS' },
  { value: '511025', label: '511025 - ASESORIA JURIDICA' },
  { value: '511030', label: '511030 - ASESORIA FINANCIERA' },
  { value: '511035', label: '511035 - ASESORIA TECNICA' },
  { value: '511095', label: '511095 - OTROS' },
  { value: '511099', label: '511099 - AJUSTES POR INFLACION' },
  { value: '5115', label: '5115 - IMPUESTOS' },
  { value: '511505', label: '511505 - INDUSTRIA Y COMERCIO' },
  { value: '511510', label: '511510 - DE TIMBRES' },
  { value: '511515', label: '511515 - A LA PROPIEDAD RAIZ' },
  { value: '511520', label: '511520 - DERECHOS SOBRE INSTRUMENTOS PUBLICOS' },
  { value: '511525', label: '511525 - DE VALORIZACION' },
  { value: '511530', label: '511530 - DE TURISMO' },
  { value: '511535', label: '511535 - TASA POR UTILIZACION DE PUERTOS' },
  { value: '511540', label: '511540 - DE VEHICULOS' },
  { value: '511545', label: '511545 - DE ESPECTACULOS PUBLICOS' },
  { value: '511550', label: '511550 - CUOTAS DE FOMENTO' },
  { value: '511570', label: '511570 - IVA DESCONTABLE' },
  { value: '511595', label: '511595 - OTROS' },
  { value: '511599', label: '511599 - AJUSTES POR INFLACION' },
  { value: '5120', label: '5120 - ARRENDAMIENTOS' },
  { value: '512005', label: '512005 - TERRENOS' },
  { value: '512010', label: '512010 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '512015', label: '512015 - MAQUINARIA Y EQUIPO' },
  { value: '512020', label: '512020 - EQUIPO DE OFICINA' },
  { value: '512025', label: '512025 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '512030', label: '512030 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '512035', label: '512035 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '512040', label: '512040 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '512045', label: '512045 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '512050', label: '512050 - FLOTA Y EQUIPO AEREO' },
  { value: '512055', label: '512055 - FLOTA Y EQUIPO FERREO' },
  { value: '512060', label: '512060 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '512065', label: '512065 - AERODROMOS' },
  { value: '512070', label: '512070 - SEMOVIENTES' },
  { value: '512095', label: '512095 - OTROS' },
  { value: '512099', label: '512099 - AJUSTES POR INFLACION' },
  { value: '5125', label: '5125 - CONTRIBUCIONES Y AFILIACIONES' },
  { value: '512505', label: '512505 - CONTRIBUCIONES' },
  { value: '512510', label: '512510 - AFILIACIONES Y SOSTENIMIENTO' },
  { value: '512599', label: '512599 - AJUSTES POR INFLACION' },
  { value: '5130', label: '5130 - SEGUROS' },
  { value: '513005', label: '513005 - MANEJO' },
  { value: '513010', label: '513010 - CUMPLIMIENTO' },
  { value: '513015', label: '513015 - CORRIENTE DEBIL' },
  { value: '513020', label: '513020 - VIDA COLECTIVA' },
  { value: '513025', label: '513025 - INCENDIO' },
  { value: '513030', label: '513030 - TERREMOTO' },
  { value: '513035', label: '513035 - SUSTRACCION Y HURTO' },
  { value: '513040', label: '513040 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '513045', label: '513045 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '513050', label: '513050 - FLOTA Y EQUIPO AEREO' },
  { value: '513055', label: '513055 - FLOTA Y EQUIPO FERREO' },
  { value: '513060', label: '513060 - RESPONSABILIDAD CIVIL Y EXTRACONTRACTUAL' },
  { value: '513065', label: '513065 - VUELO' },
  { value: '513070', label: '513070 - ROTURA DE MAQUINARIA' },
  { value: '513075', label: '513075 - OBLIGATORIO ACCIDENTE DE TRANSITO' },
  { value: '513080', label: '513080 - LUCRO CESANTE' },
  { value: '513095', label: '513095 - OTROS' },
  { value: '513099', label: '513099 - AJUSTES POR INFLACION' },
  { value: '5135', label: '5135 - SERVICIOS' },
  { value: '513505', label: '513505 - ASEO Y VIGILANCIA' },
  { value: '513510', label: '513510 - TEMPORALES' },
  { value: '513515', label: '513515 - ASISTENCIA TECNICA' },
  { value: '513520', label: '513520 - PROCESAMIENTO ELECTRONICO DE DATOS' },
  { value: '513525', label: '513525 - ACUEDUCTO Y ALCANTARILLADO' },
  { value: '513530', label: '513530 - ENERGIA ELECTRICA' },
  { value: '513535', label: '513535 - TELEFONO' },
  { value: '513540', label: '513540 - CORREO, PORTES Y TELEGRAMAS' },
  { value: '513545', label: '513545 - FAX Y TELEX' },
  { value: '513550', label: '513550 - TRANSPORTE, FLETES Y ACARREOS' },
  { value: '513555', label: '513555 - GAS' },
  { value: '513595', label: '513595 - OTROS' },
  { value: '513599', label: '513599 - AJUSTES POR INFLACION' },
  { value: '5140', label: '5140 - GASTOS LEGALES' },
  { value: '514005', label: '514005 - NOTARIALES' },
  { value: '514010', label: '514010 - REGISTRO MERCANTIL' },
  { value: '514015', label: '514015 - TRAMITES Y LICENCIAS' },
  { value: '514020', label: '514020 - ADUANEROS' },
  { value: '514025', label: '514025 - CONSULARES' },
  { value: '514095', label: '514095 - OTROS' },
  { value: '514099', label: '514099 - AJUSTES POR INFLACION' },
  { value: '5145', label: '5145 - MANTENIMIENTO Y REPARACIONES' },
  { value: '514505', label: '514505 - TERRENOS' },
  { value: '514510', label: '514510 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '514515', label: '514515 - MAQUINARIA Y EQUIPO' },
  { value: '514520', label: '514520 - EQUIPO DE OFICINA' },
  { value: '514525', label: '514525 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '514530', label: '514530 - EQUIPO MEDICO-CIENTIFICO' },
  { value: '514535', label: '514535 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '514540', label: '514540 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '514545', label: '514545 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '514550', label: '514550 - FLOTA Y EQUIPO AEREO' },
  { value: '514555', label: '514555 - FLOTA Y EQUIPO FERREO' },
  { value: '514560', label: '514560 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '514565', label: '514565 - ARMAMENTO DE VIGILANCIA' },
  { value: '514570', label: '514570 - VIAS DE COMUNICACION' },
  { value: '514599', label: '514599 - AJUSTES POR INFLACION' },
  { value: '5150', label: '5150 - ADECUACION E INSTALACION' },
  { value: '515005', label: '515005 - INSTALACIONES ELECTRICAS' },
  { value: '515010', label: '515010 - ARREGLOS ORNAMENTALES' },
  { value: '515015', label: '515015 - REPARACIONES LOCATIVAS' },
  { value: '515095', label: '515095 - OTROS' },
  { value: '515099', label: '515099 - AJUSTES POR INFLACION' },
  { value: '5155', label: '5155 - GASTOS DE VIAJE' },
  { value: '515505', label: '515505 - ALOJAMIENTO Y MANUTENCION' },
  { value: '515510', label: '515510 - PASAJES FLUVIALES Y/O MARITIMOS' },
  { value: '515515', label: '515515 - PASAJES AEREOS' },
  { value: '515520', label: '515520 - PASAJES TERRESTRES' },
  { value: '515525', label: '515525 - PASAJES FERREOS' },
  { value: '515595', label: '515595 - OTROS' },
  { value: '515599', label: '515599 - AJUSTES POR INFLACION' },
  { value: '5160', label: '5160 - DEPRECIACIONES' },
  { value: '516005', label: '516005 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '516010', label: '516010 - MAQUINARIA Y EQUIPO' },
  { value: '516015', label: '516015 - EQUIPO DE OFICINA' },
  { value: '516020', label: '516020 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '516025', label: '516025 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '516030', label: '516030 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '516035', label: '516035 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '516040', label: '516040 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '516045', label: '516045 - FLOTA Y EQUIPO AEREO' },
  { value: '516050', label: '516050 - FLOTA Y EQUIPO FERREO' },
  { value: '516055', label: '516055 - ACUEDUCTOS, PLANTAS Y REDES' },
  { value: '516060', label: '516060 - ARMAMENTO DE VIGILANCIA' },
  { value: '516099', label: '516099 - AJUSTES POR INFLACION' },
  { value: '5165', label: '5165 - AMORTIZACIONES' },
  { value: '516505', label: '516505 - VIAS DE COMUNICACION' },
  { value: '516510', label: '516510 - INTANGIBLES' },
  { value: '516515', label: '516515 - CARGOS DIFERIDOS' },
  { value: '516595', label: '516595 - OTRAS' },
  { value: '516599', label: '516599 - AJUSTES POR INFLACION' },
  { value: '5195', label: '5195 - DIVERSOS' },
  { value: '519505', label: '519505 - COMISIONES' },
  { value: '519510', label: '519510 - LIBROS, SUSCRIPCIONES, PERIODICOS Y REVISTAS' },
  { value: '519515', label: '519515 - MUSICA AMBIENTAL' },
  { value: '519520', label: '519520 - GASTOS DE REPRESENTACION Y RELACIONES PUBLICAS' },
  { value: '519525', label: '519525 - ELEMENTOS DE ASEO Y CAFETERIA' },
  { value: '519530', label: '519530 - UTILES, PAPELERIA Y FOTOCOPIAS' },
  { value: '519535', label: '519535 - COMBUSTIBLES Y LUBRICANTES' },
  { value: '519540', label: '519540 - ENVASES Y EMPAQUES' },
  { value: '519545', label: '519545 - TAXIS Y BUSES' },
  { value: '519550', label: '519550 - ESTAMPILLAS' },
  { value: '519555', label: '519555 - MICROFILMACION' },
  { value: '519560', label: '519560 - CASINO Y RESTAURANTE' },
  { value: '519565', label: '519565 - PARQUEADEROS' },
  { value: '519570', label: '519570 - INDEMNIZACION POR DAÑOS A TERCEROS' },
  { value: '519575', label: '519575 - POLVORA Y SIMILARES' },
  { value: '519595', label: '519595 - OTROS' },
  { value: '519599', label: '519599 - AJUSTES POR INFLACION' },
  { value: '5199', label: '5199 - PROVISIONES' },
  { value: '519905', label: '519905 - INVERSIONES' },
  { value: '519910', label: '519910 - DEUDORES' },
  { value: '519915', label: '519915 - PROPIEDADES, PLANTA Y EQUIPO' },
  { value: '519995', label: '519995 - OTROS ACTIVOS' },
  { value: '519999', label: '519999 - AJUSTES POR INFLACION' },
  { value: '52', label: '52 - OPERACIONALES DE VENTAS' },
  { value: '5205', label: '5205 - GASTOS DE PERSONAL' },
  { value: '520503', label: '520503 - SALARIO INTEGRAL' },
  { value: '520506', label: '520506 - SUELDOS' },
  { value: '520512', label: '520512 - JORNALES' },
  { value: '520515', label: '520515 - HORAS EXTRAS Y RECARGOS' },
  { value: '520518', label: '520518 - COMISIONES' },
  { value: '520521', label: '520521 - VIATICOS' },
  { value: '520524', label: '520524 - INCAPACIDADES' },
  { value: '520527', label: '520527 - AUXILIO DE TRANSPORTE' },
  { value: '520530', label: '520530 - CESANTIAS' },
  { value: '520533', label: '520533 - INTERESES SOBRE CESANTIAS' },
  { value: '520536', label: '520536 - PRIMA DE SERVICIOS' },
  { value: '520539', label: '520539 - VACACIONES' },
  { value: '520542', label: '520542 - PRIMAS EXTRALEGALES' },
  { value: '520545', label: '520545 - AUXILIOS' },
  { value: '520548', label: '520548 - BONIFICACIONES' },
  { value: '520551', label: '520551 - DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: '520554', label: '520554 - SEGUROS' },
  { value: '520557', label: '520557 - CUOTAS PARTES PENSIONES DE JUBILACION' },
  { value: '520558', label: '520558 - AMORTIZACION CALCULO ACTUARIAL PENSIONES DE JUBILACION' },
  { value: '520559', label: '520559 - PENSIONES DE JUBILACION' },
  { value: '520560', label: '520560 - INDEMNIZACIONES LABORALES' },
  { value: '520563', label: '520563 - CAPACITACION AL PERSONAL' },
  { value: '520566', label: '520566 - GASTOS DEPORTIVOS Y DE RECREACION' },
  { value: '520569', label: '520569 - APORTES AL I.S.S' },
  { value: '520572', label: '520572 - APORTES CAJAS DE COMPENSACION FAMILIAR' },
  { value: '520575', label: '520575 - APORTES I.C.B.F.' },
  { value: '520578', label: '520578 - SENA' },
  { value: '520581', label: '520581 - APORTES SINDICALES' },
  { value: '520584', label: '520584 - GASTOS MEDICOS Y DROGAS' },
  { value: '520595', label: '520595 - OTROS' },
  { value: '520599', label: '520599 - AJUSTES POR INFLACION' },
  { value: '5210', label: '5210 - HONORARIOS' },
  { value: '521005', label: '521005 - JUNTA DIRECTIVA' },
  { value: '521010', label: '521010 - REVISORIA FISCAL' },
  { value: '521015', label: '521015 - AUDITORIA EXTERNA' },
  { value: '521020', label: '521020 - AVALUOS' },
  { value: '521025', label: '521025 - ASESORIA JURIDICA' },
  { value: '521030', label: '521030 - ASESORIA FINANCIERA' },
  { value: '521035', label: '521035 - ASESORIA TECNICA' },
  { value: '521095', label: '521095 - OTROS' },
  { value: '521099', label: '521099 - AJUSTES POR INFLACION' },
  { value: '5215', label: '5215 - IMPUESTOS' },
  { value: '521505', label: '521505 - INDUSTRIA Y COMERCIO' },
  { value: '521510', label: '521510 - DE TIMBRES' },
  { value: '521515', label: '521515 - A LA PROPIEDAD RAIZ' },
  { value: '521520', label: '521520 - DERECHOS SOBRE INSTRUMENTOS PUBLICOS' },
  { value: '521525', label: '521525 - DE VALORIZACION' },
  { value: '521530', label: '521530 - DE TURISMO' },
  { value: '521535', label: '521535 - TASA POR UTILIZACION DE PUERTOS' },
  { value: '521540', label: '521540 - DE VEHICULOS' },
  { value: '521545', label: '521545 - DE ESPECTACULOS PUBLICOS' },
  { value: '521550', label: '521550 - CUOTAS DE FOMENTO' },
  { value: '521555', label: '521555 - LICORES' },
  { value: '521560', label: '521560 - CERVEZAS' },
  { value: '521565', label: '521565 - CIGARRILLOS' },
  { value: '521570', label: '521570 - IVA DESCONTABLE' },
  { value: '521595', label: '521595 - OTROS' },
  { value: '521599', label: '521599 - AJUSTES POR INFLACION' },
  { value: '5220', label: '5220 - ARRENDAMIENTOS' },
  { value: '522005', label: '522005 - TERRENOS' },
  { value: '522010', label: '522010 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '522015', label: '522015 - MAQUINARIA Y EQUIPO' },
  { value: '522020', label: '522020 - EQUIPO DE OFICINA' },
  { value: '522025', label: '522025 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '522030', label: '522030 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '522035', label: '522035 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '522040', label: '522040 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '522045', label: '522045 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '522050', label: '522050 - FLOTA Y EQUIPO AEREO' },
  { value: '522055', label: '522055 - FLOTA Y EQUIPO FERREO' },
  { value: '522060', label: '522060 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '522065', label: '522065 - AERODROMOS' },
  { value: '522070', label: '522070 - SEMOVIENTES' },
  { value: '522095', label: '522095 - OTROS' },
  { value: '522099', label: '522099 - AJUSTES POR INFLACION' },
  { value: '5225', label: '5225 - CONTRIBUCIONES Y AFILIACIONES' },
  { value: '522505', label: '522505 - CONTRIBUCIONES' },
  { value: '522510', label: '522510 - AFILIACIONES Y SOSTENIMIENTO' },
  { value: '522599', label: '522599 - AJUSTES POR INFLACION' },
  { value: '5230', label: '5230 - SEGUROS' },
  { value: '523005', label: '523005 - MANEJO' },
  { value: '523010', label: '523010 - CUMPLIMIENTO' },
  { value: '523015', label: '523015 - CORRIENTE DEBIL' },
  { value: '523020', label: '523020 - VIDA COLECTIVA' },
  { value: '523025', label: '523025 - INCENDIO' },
  { value: '523030', label: '523030 - TERREMOTO' },
  { value: '523035', label: '523035 - SUSTRACCION Y HURTO' },
  { value: '523040', label: '523040 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '523045', label: '523045 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '523050', label: '523050 - FLOTA Y EQUIPO AEREO' },
  { value: '523055', label: '523055 - FLOTA Y EQUIPO FERREO' },
  { value: '523060', label: '523060 - RESPONSABILIDAD CIVIL Y EXTRACONTRACTUAL' },
  { value: '523065', label: '523065 - VUELO' },
  { value: '523070', label: '523070 - ROTURA DE MAQUINARIA' },
  { value: '523075', label: '523075 - OBLIGATORIO ACCIDENTE DE TRANSITO' },
  { value: '523080', label: '523080 - LUCRO CESANTE' },
  { value: '523095', label: '523095 - OTROS' },
  { value: '523099', label: '523099 - AJUSTES POR INFLACION' },
  { value: '5235', label: '5235 - SERVICIOS' },
  { value: '523505', label: '523505 - ASEO Y VIGILANCIA' },
  { value: '523510', label: '523510 - TEMPORALES' },
  { value: '523515', label: '523515 - ASISTENCIA TECNICA' },
  { value: '523520', label: '523520 - PROCESAMIENTO ELECTRONICO DE DATOS' },
  { value: '523525', label: '523525 - ACUEDUCTO Y ALCANTARILLADO' },
  { value: '523530', label: '523530 - ENERGIA ELECTRICA' },
  { value: '523535', label: '523535 - TELEFONO' },
  { value: '523540', label: '523540 - CORREO, PORTES Y TELEGRAMAS' },
  { value: '523545', label: '523545 - FAX Y TELEX' },
  { value: '523550', label: '523550 - TRANSPORTE, FLETES Y ACARREOS' },
  { value: '523555', label: '523555 - GAS' },
  { value: '523560', label: '523560 - PROPAGANDA Y PUBLICIDAD' },
  { value: '523595', label: '523595 - OTROS' },
  { value: '523599', label: '523599 - AJUSTES POR INFLACION' },
  { value: '5240', label: '5240 - GASTOS LEGALES' },
  { value: '524005', label: '524005 - NOTARIALES' },
  { value: '524010', label: '524010 - REGISTRO MERCANTIL' },
  { value: '524015', label: '524015 - TRAMITES Y LICENCIAS' },
  { value: '524020', label: '524020 - ADUANEROS' },
  { value: '524025', label: '524025 - CONSULARES' },
  { value: '524095', label: '524095 - OTROS' },
  { value: '524099', label: '524099 - AJUSTES POR INFLACION' },
  { value: '5245', label: '5245 - MANTENIMIENTO Y REPARACIONES' },
  { value: '524505', label: '524505 - TERRENOS' },
  { value: '524510', label: '524510 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '524515', label: '524515 - MAQUINARIA Y EQUIPO' },
  { value: '524520', label: '524520 - EQUIPO DE OFICINA' },
  { value: '524525', label: '524525 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '524530', label: '524530 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '524535', label: '524535 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '524540', label: '524540 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '524545', label: '524545 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '524550', label: '524550 - FLOTA Y EQUIPO AEREO' },
  { value: '524555', label: '524555 - FLOTA Y EQUIPO FERREO' },
  { value: '524560', label: '524560 - ACUEDUCTOS PLANTAS Y REDES' },
  { value: '524565', label: '524565 - ARMAMENTO DE VIGILANCIA' },
  { value: '524570', label: '524570 - VIAS DE COMUNICACION' },
  { value: '524599', label: '524599 - AJUSTES POR INFLACION' },
  { value: '5250', label: '5250 - ADECUACION E INSTALACION' },
  { value: '525005', label: '525005 - INSTALACIONES ELECTRICAS' },
  { value: '525010', label: '525010 - ARREGLOS ORNAMENTALES' },
  { value: '525015', label: '525015 - REPARACIONES LOCATIVAS' },
  { value: '525095', label: '525095 - OTROS' },
  { value: '525099', label: '525099 - AJUSTES POR INFLACION' },
  { value: '5255', label: '5255 - GASTOS DE VIAJE' },
  { value: '525505', label: '525505 - ALOJAMIENTO Y MANUTENCION' },
  { value: '525510', label: '525510 - PASAJES FLUVIALES Y/O MARITIMOS' },
  { value: '525515', label: '525515 - PASAJES AEREOS' },
  { value: '525520', label: '525520 - PASAJES TERRESTRES' },
  { value: '525525', label: '525525 - PASAJES FERREOS' },
  { value: '525595', label: '525595 - OTROS' },
  { value: '525599', label: '525599 - AJUSTES POR INFLACION' },
  { value: '5260', label: '5260 - DEPRECIACIONES' },
  { value: '526005', label: '526005 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '526010', label: '526010 - MAQUINARIA Y EQUIPO' },
  { value: '526015', label: '526015 - EQUIPO DE OFICINA' },
  { value: '526020', label: '526020 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '526025', label: '526025 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '526030', label: '526030 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '526035', label: '526035 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '526040', label: '526040 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '526045', label: '526045 - FLOTA Y EQUIPO AEREO' },
  { value: '526050', label: '526050 - FLOTA Y EQUIPO FERREO' },
  { value: '526055', label: '526055 - ACUEDUCTOS, PLANTAS Y REDES' },
  { value: '526060', label: '526060 - ARMAMENTO DE VIGILANCIA' },
  { value: '526065', label: '526065 - ENVASES Y EMPAQUES' },
  { value: '526099', label: '526099 - AJUSTES POR INFLACION' },
  { value: '5265', label: '5265 - AMORTIZACIONES' },
  { value: '526505', label: '526505 - VIAS DE COMUNICACION' },
  { value: '526510', label: '526510 - INTANGIBLES' },
  { value: '526515', label: '526515 - CARGOS DIFERIDOS' },
  { value: '526595', label: '526595 - OTRAS' },
  { value: '526599', label: '526599 - AJUSTES POR INFLACION' },
  { value: '5270', label: '5270 - FINANCIEROS - REAJUSTE DEL SISTEMA' },
  { value: '527001', label: '527001 - a 527098' },
  { value: '527099', label: '527099 - AJUSTES POR INFLACION' },
  { value: '5295', label: '5295 - DIVERSOS' },
  { value: '529505', label: '529505 - COMISIONES' },
  { value: '529510', label: '529510 - LIBROS, SUSCRIPCIONES, PERIODICOS Y REVISTAS' },
  { value: '529515', label: '529515 - MUSICA AMBIENTAL' },
  { value: '529520', label: '529520 - GASTOS DE REPRESENTACION Y RELACIONES PUBLICAS' },
  { value: '529525', label: '529525 - ELEMENTOS DE ASEO Y CAFETERIA' },
  { value: '529530', label: '529530 - UTILES, PAPELERIA Y FOTOCOPIAS' },
  { value: '529535', label: '529535 - COMBUSTIBLES Y LUBRICANTES' },
  { value: '529540', label: '529540 - ENVASES Y EMPAQUES' },
  { value: '529545', label: '529545 - TAXIS Y BUSES' },
  { value: '529550', label: '529550 - ESTAMPILLAS' },
  { value: '529555', label: '529555 - MICROFILMACION' },
  { value: '529560', label: '529560 - CASINO Y RESTAURANTE' },
  { value: '529565', label: '529565 - PARQUEADEROS' },
  { value: '529570', label: '529570 - INDEMNIZACION POR DAÑOS A TERCEROS' },
  { value: '529575', label: '529575 - POLVORA Y SIMILARES' },
  { value: '529595', label: '529595 - OTROS' },
  { value: '529599', label: '529599 - AJUSTES POR INFLACION' },
  { value: '5299', label: '5299 - PROVISIONES' },
  { value: '529905', label: '529905 - INVERSIONES' },
  { value: '529910', label: '529910 - DEUDORES' },
  { value: '529915', label: '529915 - INVENTARIOS' },
  { value: '529920', label: '529920 - PROPIEDADES, PLANTA Y EQUIPO' },
  { value: '529995', label: '529995 - OTROS ACTIVOS' },
  { value: '529999', label: '529999 - AJUSTES POR INFLACION' },
  { value: '53', label: '53 - NO OPERACIONALES' },
  { value: '5305', label: '5305 - FINANCIEROS' },
  { value: '530505', label: '530505 - GASTOS BANCARIOS' },
  { value: '530510', label: '530510 - REAJUSTE MONETARIO - UPAC' },
  { value: '530515', label: '530515 - COMISIONES' },
  { value: '530520', label: '530520 - INTERESES' },
  { value: '530525', label: '530525 - DIFERENCIA EN CAMBIO' },
  { value: '530530', label: '530530 - GASTOS EN NEGOCIACION CERTIFICADOS DE CAMBIO' },
  { value: '530535', label: '530535 - DESCUENTOS COMERCIALES CONDICIONADOS' },
  { value: '530540', label: '530540 - GASTOS MANEJO Y EMISION DE BONOS' },
  { value: '530545', label: '530545 - PRIMA AMORTIZADA' },
  { value: '530595', label: '530595 - OTROS' },
  { value: '530599', label: '530599 - AJUSTES POR INFLACION' },
  { value: '5310', label: '5310 - PERDIDA EN VENTA Y RETIRO DE BIENES' },
  { value: '531005', label: '531005 - VENTA DE INVERSIONES' },
  { value: '531010', label: '531010 - VENTA DE CARTERA' },
  { value: '531015', label: '531015 - VENTA DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: '531020', label: '531020 - VENTA DE INTANGIBLES' },
  { value: '531025', label: '531025 - VENTA DE OTROS ACTIVOS' },
  { value: '531030', label: '531030 - RETIRO DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: '531035', label: '531035 - RETIRO DE OTROS ACTIVOS' },
  { value: '531040', label: '531040 - PERDIDAS POR SINIESTROS' },
  { value: '531095', label: '531095 - OTROS' },
  { value: '531099', label: '531099 - AJUSTES POR INFLACION' },
  { value: '5315', label: '5315 - GASTOS EXTRAORDINARIOS' },
  { value: '531505', label: '531505 - COSTAS Y PROCESOS JUDICIALES' },
  { value: '531510', label: '531510 - ACTIVIDADES CULTURALES Y CIVICAS' },
  { value: '531515', label: '531515 - COSTOS Y GASTOS DE EJERCICIOS ANTERIORES' },
  { value: '531520', label: '531520 - IMPUESTOS ASUMIDOS' },
  { value: '531595', label: '531595 - OTROS' },
  { value: '531599', label: '531599 - AJUSTES POR INFLACION' },
  { value: '5395', label: '5395 - GASTOS DIVERSOS' },
  { value: '539505', label: '539505 - DEMANDAS LABORALES' },
  { value: '539510', label: '539510 - DEMANDAS POR INCUMPLIMIENTO DE CONTRATOS' },
  { value: '539515', label: '539515 - INDEMNIZACIONES' },
  { value: '539520', label: '539520 - MULTAS, SANCIONES Y LITIGIOS' },
  { value: '539525', label: '539525 - DONACIONES' },
  { value: '539530', label: '539530 - CONSTITUCION DE GARANTIAS' },
  { value: '539535', label: '539535 - AMORTIZACION DE BIENES ENTREGADOS EN COMODATO' },
  { value: '539595', label: '539595 - OTROS' },
  { value: '539599', label: '539599 - AJUSTES POR INFLACION' },
  { value: '54', label: '54 - IMPUESTO DE RENTA Y COMPLEMENTARIOS' },
  { value: '5405', label: '5405 - IMPUESTO DE RENTA Y COMPLEMENTARIOS' },
  { value: '540505', label: '540505 - IMPUESTO DE RENTA Y COMPLEMENTARIOS' },
  { value: '59', label: '59 - GANANCIAS Y PERDIDAS' },
  { value: '5905', label: '5905 - GANANCIAS Y PERDIDAS' },
  { value: '590505', label: '590505 - GANANCIAS Y PERDIDAS' },
  { value: '6', label: '6 - COSTOS DE VENTAS' },
  { value: '61', label: '61 - COSTO DE VENTAS Y DE PRESTACION DE SERVICIOS' },
  { value: '6105', label: '6105 - AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: '610505', label: '610505 - CULTIVO DE CEREALES' },
  { value: '610510', label: '610510 - CULTIVOS DE HORTALIZAS, LEGUMBRES Y PLANTAS ORNAMENTALES' },
  { value: '610515', label: '610515 - CULTIVOS DE FRUTAS, NUECES Y PLANTAS AROMATICAS' },
  { value: '610520', label: '610520 - CULTIVO DE CAFE' },
  { value: '610525', label: '610525 - CULTIVO DE FLORES' },
  { value: '610530', label: '610530 - CULTIVO DE CAÑA DE AZUCAR' },
  { value: '610535', label: '610535 - CULTIVO DE ALGODON Y PLANTAS PARA MATERIAL TEXTIL' },
  { value: '610540', label: '610540 - CULTIVO DE BANANO' },
  { value: '610545', label: '610545 - OTROS CULTIVOS AGRICOLAS' },
  { value: '610550', label: '610550 - CRIA DE OVEJAS, CABRAS, ASNOS, MULAS Y BURDEGANOS' },
  { value: '610555', label: '610555 - CRIA DE GANADO CABALLAR Y VACUNO.' },
  { value: '610560', label: '610560 - PRODUCCION AVICOLA' },
  { value: '610565', label: '610565 - CRIA DE OTROS ANIMALES' },
  { value: '610570', label: '610570 - SERVICIOS AGRICOLAS Y GANADEROS' },
  { value: '610575', label: '610575 - ACTIVIDAD DE CAZA' },
  { value: '610580', label: '610580 - ACTIVIDAD DE SILVICULTURA' },
  { value: '610595', label: '610595 - ACTIVIDADES CONEXAS' },
  { value: '610599', label: '610599 - AJUSTES POR INFLACION' },
  { value: '6110', label: '6110 - PESCA' },
  { value: '611005', label: '611005 - ACTIVIDAD DE PESCA' },
  { value: '611010', label: '611010 - EXPLOTACION DE CRIADEROS DE PECES' },
  { value: '611095', label: '611095 - ACTIVIDADES CONEXAS' },
  { value: '611099', label: '611099 - AJUSTES POR INFLACION' },
  { value: '6115', label: '6115 - EXPLOTACION DE MINAS Y CANTERAS' },
  { value: '611505', label: '611505 - CARBON' },
  { value: '611510', label: '611510 - PETROLEO CRUDO' },
  { value: '611512', label: '611512 - GAS NATURAL' },
  { value: '611514', label: '611514 - SERVICIOS RELACIONADOS CON EXTRACCION DE PETROLEO Y GAS' },
  { value: '611515', label: '611515 - MINERALES DE HIERRO' },
  { value: '611520', label: '611520 - MINERALES METALIFEROS NO FERROSOS' },
  { value: '611525', label: '611525 - PIEDRA, ARENA Y ARCILLA' },
  { value: '611527', label: '611527 - PIEDRAS PRECIOSAS' },
  { value: '611528', label: '611528 - ORO' },
  { value: '611530', label: '611530 - OTRAS MINAS Y CANTERAS' },
  { value: '611532', label: '611532 - PRESTACION DE SERVICIOS SECTOR MINERO' },
  { value: '611595', label: '611595 - ACTIVIDADES CONEXAS' },
  { value: '611599', label: '611599 - AJUSTES POR INFLACION' },
  { value: '6120', label: '6120 - INDUSTRIAS MANUFACTURERAS' },
  { value: '612001', label: '612001 - PRODUCCION Y PROCESAMIENTO DE CARNES Y PRODUCTOS CARNICOS' },
  { value: '612002', label: '612002 - PRODUCTOS DE PESCADO' },
  { value: '612003', label: '612003 - PRODUCTOS DE FRUTAS, LEGUMBRES Y HORTALIZAS' },
  { value: '612004', label: '612004 - ELABORACION DE ACEITES Y GRASAS' },
  { value: '612005', label: '612005 - ELABORACION DE PRODUCTOS LACTEOS' },
  { value: '612006', label: '612006 - ELABORACION DE PRODUCTOS DE MOLINERIA' },
  { value: '612007', label: '612007 - ELABORACION DE ALMIDONES Y DERIVADOS' },
  { value: '612008', label: '612008 - ELABORACION DE ALIMENTOS PARA ANIMALES' },
  { value: '612009', label: '612009 - ELABORACION DE PRODUCTOS PARA PANADERIA' },
  { value: '612010', label: '612010 - ELABORACION DE AZUCAR Y MELAZAS' },
  { value: '612011', label: '612011 - ELABORACION DE CACAO, CHOCOLATE Y CONFITERIA' },
  { value: '612012', label: '612012 - ELABORACION DE PASTAS  Y PRODUCTOS FARINACEOS' },
  { value: '612013', label: '612013 - ELABORACION DE PRODUCTOS DE CAFE' },
  { value: '612014', label: '612014 - ELABORACION DE OTROS PRODUCTOS ALIMENTICIOS' },
  { value: '612015', label: '612015 - ELABORACION DE BEBIDAS ALCOHOLICAS Y ALCOHOL ETILICO' },
  { value: '612016', label: '612016 - ELABORACION DE VINOS' },
  { value: '612017', label: '612017 - ELABORACION DE BEBIDAS MALTEADAS Y DE MALTA' },
  { value: '612018', label: '612018 - ELABORACION DE BEBIDAS NO ALCOHOLICAS' },
  { value: '612019', label: '612019 - ELABORACION DE PRODUCTOS DE TABACO' },
  { value: '612020', label: '612020 - PREPARACION E HILATURA DE FIBRAS TEXTILES Y TEJEDURIA' },
  { value: '612021', label: '612021 - ACABADO DE PRODUCTOS TEXTILES' },
  { value: '612022', label: '612022 - ELABORACION DE ARTICULOS DE MATERIALES TEXTILES' },
  { value: '612023', label: '612023 - ELABORACION DE TAPICES Y ALFOMBRAS' },
  { value: '612024', label: '612024 - ELABORACION DE CUERDAS, CORDELES, BRAMANTES Y REDES' },
  { value: '612025', label: '612025 - ELABORACION DE OTROS PRODUCTOS TEXTILES' },
  { value: '612026', label: '612026 - ELABORACION DE TEJIDOS' },
  { value: '612027', label: '612027 - ELABORACION DE PRENDAS DE VESTIR' },
  { value: '612028', label: '612028 - PREPARACION, ADOBO Y TEÑIDO DE PIELES' },
  { value: '612029', label: '612029 - CURTIDO, ADOBO O PREPARACION DE CUERO' },
  { value: '612030', label: '612030 - ELABORACION DE MALETAS, BOLSOS Y SIMILARES' },
  { value: '612031', label: '612031 - ELABORACION DE CALZADO' },
  { value: '612032', label: '612032 - PRODUCCION DE MADERA, ARTICULOS DE MADERA Y CORCHO' },
  { value: '612033', label: '612033 - ELABORACION DE PASTA Y PRODUCTOS DE MADERA, PAPEL Y CARTON' },
  { value: '612034', label: '612034 - EDICIONES Y PUBLICACIONES' },
  { value: '612035', label: '612035 - IMPRESION' },
  { value: '612036', label: '612036 - SERVICIOS RELACIONADOS CON LA EDICION Y LA IMPRESION' },
  { value: '612037', label: '612037 - REPRODUCCION DE GRABACIONES' },
  { value: '612038', label: '612038 - ELABORACION DE PRODUCTOS DE HORNO DE COQUE' },
  { value: '612039', label: '612039 - ELABORACION DE PRODUCTOS DE LA REFINACION DE PETROLEO' },
  { value: '612040', label: '612040 - ELABORACION DE SUSTANCIAS QUIMICAS BASICAS' },
  { value: '612041', label: '612041 - ELABORACION DE ABONOS Y COMPUESTOS DE NITROGENO' },
  { value: '612042', label: '612042 - ELABORACION DE PLASTICO Y CAUCHO SINTETICO' },
  { value: '612043', label: '612043 - ELABORACION DE PRODUCTOS QUIMICOS DE USO AGROPECUARIO' },
  { value: '612044', label: '612044 - ELABORACION DE PINTURAS, TINTAS Y MASILLAS' },
  { value: '612045', label: '612045 - ELABORACION DE PRODUCTOS FARMACEUTICOS Y BOTANICOS' },
  { value: '612046', label: '612046 - ELABORACION DE JABONES, DETERGENTES Y PREPARADOS DE TOCADOR' },
  { value: '612047', label: '612047 - ELABORACION DE OTROS PRODUCTOS QUIMICOS' },
  { value: '612048', label: '612048 - ELABORACION DE FIBRAS' },
  { value: '612049', label: '612049 - ELABORACION DE OTROS PRODUCTOS DE CAUCHO' },
  { value: '612050', label: '612050 - ELABORACION DE PRODUCTOS DE PLASTICO' },
  { value: '612051', label: '612051 - ELABORACION DE VIDRIO Y PRODUCTOS DE VIDRIO' },
  { value: '612052', label: '612052 - ELABORACION DE PRODUCTOS DE CERAMICA, LOZA, PIEDRA, ARCILLA Y PORCELANA' },
  { value: '612053', label: '612053 - ELABORACION DE CEMENTO, CAL Y YESO' },
  { value: '612054', label: '612054 - ELABORACION DE ARTICULOS DE HORMIGON, CEMENTO Y YESO' },
  { value: '612055', label: '612055 - CORTE, TALLADO Y ACABADO DE LA PIEDRA' },
  { value: '612056', label: '612056 - ELABORACION DE OTROS PRODUCTOS MINERALES NO METALICOS' },
  { value: '612057', label: '612057 - INDUSTRIAS BASICAS Y FUNDICION DE HIERRO Y ACERO' },
  { value: '612058', label: '612058 - PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y DE METALES NO FERROSOS' },
  { value: '612059', label: '612059 - FUNDICION DE METALES NO FERROSOS' },
  { value: '612060', label: '612060 - FABRICACION DE PRODUCTOS METALICOS PARA USO ESTRUCTURAL' },
  { value: '612061', label: '612061 - FORJA, PRENSADO, ESTAMPADO, LAMINADO DE METAL Y PULVIMETALURGIA' },
  { value: '612062', label: '612062 - REVESTIMIENTO DE METALES Y OBRAS DE INGENIERIA MECANICA' },
  { value: '612063', label: '612063 - FABRICACION DE ARTICULOS DE FERRETERIA' },
  { value: '612064', label: '612064 - ELABORACION DE OTROS PRODUCTOS DE METAL' },
  { value: '612065', label: '612065 - FABRICACION DE MAQUINARIA Y EQUIPO' },
  { value: '612066', label: '612066 - FABRICACION DE EQUIPOS DE ELEVACION Y MANIPULACION' },
  { value: '612067', label: '612067 - ELABORACION DE APARATOS DE USO DOMESTICO' },
  { value: '612068', label: '612068 - ELABORACION DE EQUIPO DE OFICINA' },
  { value: '612069', label: '612069 - ELABORACION DE PILAS Y BATERIAS PRIMARIAS' },
  { value: '612070', label: '612070 - ELABORACION DE EQUIPO DE ILUMINACION' },
  { value: '612071', label: '612071 - ELABORACION DE OTROS TIPOS DE EQUIPO ELECTRICO' },
  { value: '612072', label: '612072 - FABRICACION DE EQUIPOS DE RADIO, TELEVISION Y COMUNICACIONES' },
  { value: '612073', label: '612073 - FABRICACION DE APARATOS E INSTRUMENTOS MEDICOS' },
  { value: '612074', label: '612074 - FABRICACION DE INSTRUMENTOS DE MEDICION Y CONTROL' },
  { value: '612075', label: '612075 - FABRICACION DE INSTRUMENTOS DE OPTICA Y EQUIPO FOTOGRAFICO' },
  { value: '612076', label: '612076 - FABRICACION DE RELOJES' },
  { value: '612077', label: '612077 - FABRICACION DE VEHICULOS AUTOMOTORES' },
  { value: '612078', label: '612078 - FABRICACION DE CARROCERIAS PARA AUTOMOTORES' },
  { value: '612079', label: '612079 - FABRICACION DE PARTES PIEZAS Y ACCESORIOS PARA AUTOMOTORES' },
  { value: '612080', label: '612080 - FABRICACION Y REPARACION DE BUQUES Y OTRAS EMBARCACIONES' },
  { value: '612081', label: '612081 - FABRICACION DE LOCOMOTORAS Y MATERIAL RODANTE PARA FERROCARRILES' },
  { value: '612082', label: '612082 - FABRICACION DE AERONAVES' },
  { value: '612083', label: '612083 - FABRICACION DE MOTOCICLETAS' },
  { value: '612084', label: '612084 - FABRICACION DE BICICLETAS Y SILLAS DE RUEDAS' },
  { value: '612085', label: '612085 - FABRICACION DE OTROS TIPOS DE TRANSPORTE' },
  { value: '612086', label: '612086 - FABRICACION DE MUEBLES' },
  { value: '612087', label: '612087 - FABRICACION DE JOYAS Y ARTICULOS CONEXOS' },
  { value: '612088', label: '612088 - FABRICACION DE INSTRUMENTOS DE MUSICA' },
  { value: '612089', label: '612089 - FABRICACION DE ARTICULOS Y EQUIPO PARA DEPORTE' },
  { value: '612090', label: '612090 - FABRICACION DE JUEGOS Y JUGUETES' },
  { value: '612091', label: '612091 - RECICLAMIENTO DE DESPERDICIOS' },
  { value: '612095', label: '612095 - PRODUCTOS DE OTRAS INDUSTRIAS MANUFACTURERAS' },
  { value: '612099', label: '612099 - AJUSTES POR INFLACION' },
  { value: '6125', label: '6125 - SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: '612505', label: '612505 - GENERACION, CAPTACION Y DISTRIBUCION DE ENERGIA ELECTRICA' },
  { value: '612510', label: '612510 - FABRICACION DE GAS Y DISTRIBUCION DE COMBUSTIBLES GASEOSOS' },
  { value: '612515', label: '612515 - CAPTACION, DEPURACION Y DISTRIBUCION DE AGUA' },
  { value: '612595', label: '612595 - ACTIVIDADES CONEXAS' },
  { value: '612599', label: '612599 - AJUSTES POR INFLACION' },
  { value: '6130', label: '6130 - CONSTRUCCION' },
  { value: '613005', label: '613005 - PREPARACION DE TERRENOS' },
  { value: '613010', label: '613010 - CONSTRUCCION DE EDIFICIOS Y OBRAS DE INGENIERIA CIVIL' },
  { value: '613015', label: '613015 - ACONDICIONAMIENTO DE EDIFICIOS' },
  { value: '613020', label: '613020 - TERMINACION DE EDIFICACIONES' },
  { value: '613025', label: '613025 - ALQUILER DE EQUIPO CON OPERARIO' },
  { value: '613095', label: '613095 - ACTIVIDADES CONEXAS' },
  { value: '613099', label: '613099 - AJUSTES POR INFLACION' },
  { value: '6135', label: '6135 - COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: '613502', label: '613502 - VENTA DE VEHICULOS AUTOMOTORES' },
  { value: '613504', label: '613504 - MANTENIMIENTO, REPARACION Y LAVADO DE VEHICULOS AUTOMOTORES' },
  { value: '613506', label: '613506 - VENTA DE PARTES, PIEZAS Y ACCESORIOS DE VEHICULOS AUTOMOTORES' },
  { value: '613508', label: '613508 - VENTA DE COMBUSTIBLES SOLIDOS, LIQUIDOS, GASEOSOS' },
  { value: '613510', label: '613510 - VENTA DE LUBRICANTES, ADITIVOS, LLANTAS Y LUJOS PARA AUTOMOTORES' },
  { value: '613512', label: '613512 - VENTA A CAMBIO DE RETRIBUCION O POR CONTRATA' },
  { value: '613514', label: '613514 - VENTA DE INSUMOS, MATERIAS PRIMAS AGROPECUARIAS Y FLORES' },
  { value: '613516', label: '613516 - VENTA DE OTROS INSUMOS Y MATERIAS PRIMAS NO AGROPECUARIAS' },
  { value: '613518', label: '613518 - VENTA DE ANIMALES VIVOS Y CUEROS' },
  { value: '613520', label: '613520 - VENTA DE PRODUCTOS EN ALMACENES NO ESPECIALIZADOS' },
  { value: '613522', label: '613522 - VENTA DE PRODUCTOS AGROPECUARIOS' },
  { value: '613524', label: '613524 - VENTA DE PRODUCTOS TEXTILES, DE VESTIR, DE CUERO Y CALZADO' },
  { value: '613526', label: '613526 - VENTA DE PAPEL Y CARTON' },
  { value: '613528', label: '613528 - VENTA DE LIBROS, REVISTAS, ELEMENTOS DE PAPELERIA, UTILES Y TEXTOS ESCOLARES' },
  { value: '613530', label: '613530 - VENTA DE JUEGOS, JUGUETES Y ARTICULOS DEPORTIVOS' },
  { value: '613532', label: '613532 - VENTA DE INSTRUMENTOS QUIRURGICOS Y ORTOPEDICOS' },
  { value: '613534', label: '613534 - VENTA DE ARTICULOS EN RELOJERIAS Y JOYERIAS' },
  { value: '613536', label: '613536 - VENTA DE ELECTRODOMESTICOS Y MUEBLES' },
  { value: '613538', label: '613538 - VENTA DE PRODUCTOS DE ASEO, FARMACEUTICOS, MEDICINALES, Y ARTICULOS DE TOCADOR' },
  { value: '613540', label: '613540 - VENTA DE CUBIERTOS, VAJILLAS, CRISTALERIA, PORCELANAS, CERAMICAS Y OTROS ARTICULOS DE USO DOMESTICO' },
  { value: '613542', label: '613542 - VENTA DE MATERIALES DE CONSTRUCCION, FONTANERIA Y CALEFACCION' },
  { value: '613544', label: '613544 - VENTA DE PINTURAS Y LACAS' },
  { value: '613546', label: '613546 - VENTA DE PRODUCTOS DE VIDRIOS Y MARQUETERIA' },
  { value: '613548', label: '613548 - VENTA DE HERRAMIENTAS Y ARTICULOS DE FERRETERIA' },
  { value: '613550', label: '613550 - VENTA DE QUIMICOS' },
  { value: '613552', label: '613552 - VENTA DE PRODUCTOS INTERMEDIOS, DESPERDICIOS Y DESECHOS' },
  { value: '613554', label: '613554 - VENTA DE MAQUINARIA, EQUIPO DE OFICINA Y PROGRAMAS DE COMPUTADOR' },
  { value: '613556', label: '613556 - VENTA DE ARTICULOS EN CACHARRERIAS Y MISCELANEAS' },
  { value: '613558', label: '613558 - VENTA DE INSTRUMENTOS MUSICALES' },
  { value: '613560', label: '613560 - VENTA DE ARTICULOS EN CASAS DE EMPEÑO Y PRENDERIAS' },
  { value: '613562', label: '613562 - VENTA DE EQUIPO FOTOGRAFICO' },
  { value: '613564', label: '613564 - VENTA DE EQUIPO OPTICO Y DE PRECISION' },
  { value: '613566', label: '613566 - VENTA DE EMPAQUES' },
  { value: '613568', label: '613568 - VENTA DE EQUIPO PROFESIONAL Y CIENTIFICO' },
  { value: '613570', label: '613570 - VENTA DE LOTERIAS, RIFAS, CHANCE, APUESTAS Y SIMILARES' },
  { value: '613572', label: '613572 - REPARACION DE EFECTOS PERSONALES Y ELECTRODOMESTICOS' },
  { value: '613595', label: '613595 - VENTA DE OTROS PRODUCTOS' },
  { value: '613599', label: '613599 - AJUSTES POR INFLACION' },
  { value: '6140', label: '6140 - HOTELES Y RESTAURANTES' },
  { value: '614005', label: '614005 - HOTELERIA' },
  { value: '614010', label: '614010 - CAMPAMENTO Y OTROS TIPOS DE HOSPEDAJE' },
  { value: '614015', label: '614015 - RESTAURANTES' },
  { value: '614020', label: '614020 - BARES Y CANTINAS' },
  { value: '614095', label: '614095 - ACTIVIDADES CONEXAS' },
  { value: '614099', label: '614099 - AJUSTES POR INFLACION' },
  { value: '6145', label: '6145 - TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: '614505', label: '614505 - SERVICIO DE TRANSPORTE POR CARRETERA' },
  { value: '614510', label: '614510 - SERVICIO DE TRANSPORTE POR VIA FERREA' },
  { value: '614515', label: '614515 - SERVICIO DE TRANSPORTE POR VIA ACUATICA' },
  { value: '614520', label: '614520 - SERVICIO DE TRANSPORTE POR VIA AEREA' },
  { value: '614525', label: '614525 - SERVICIO DE TRANSPORTE POR TUBERIAS' },
  { value: '614530', label: '614530 - MANIPULACION DE CARGA' },
  { value: '614535', label: '614535 - ALMACENAMIENTO Y DEPOSITO' },
  { value: '614540', label: '614540 - SERVICIOS COMPLEMENTARIOS PARA EL TRANSPORTE' },
  { value: '614545', label: '614545 - AGENCIAS DE VIAJE' },
  { value: '614550', label: '614550 - OTRAS AGENCIAS DE TRANSPORTE' },
  { value: '614555', label: '614555 - SERVICIO POSTAL Y DE CORREO' },
  { value: '614560', label: '614560 - SERVICIO TELEFONICO' },
  { value: '614565', label: '614565 - SERVICIO DE TELEGRAFO' },
  { value: '614570', label: '614570 - SERVICIO DE TRANSMISION DE DATOS' },
  { value: '614575', label: '614575 - SERVICIO DE RADIO Y TELEVISION POR CABLE' },
  { value: '614580', label: '614580 - TRANSMISION DE SONIDO E IMAGENES POR CONTRATO' },
  { value: '614595', label: '614595 - ACTIVIDADES CONEXAS' },
  { value: '614599', label: '614599 - AJUSTES POR INFLACION' },
  { value: '6150', label: '6150 - ACTIVIDAD FINANCIERA' },
  { value: '615005', label: '615005 - DE INVERSIONES' },
  { value: '615010', label: '615010 - DE SERVICIO DE BOLSA' },
  { value: '615099', label: '615099 - AJUSTES POR INFLACION' },
  { value: '6155', label: '6155 - ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: '615505', label: '615505 - ARRENDAMIENTOS DE BIENES INMUEBLES' },
  { value: '615510', label: '615510 - INMOBILIARIAS POR RETRIBUCION O CONTRATA' },
  { value: '615515', label: '615515 - ALQUILER EQUIPO DE TRANSPORTE' },
  { value: '615520', label: '615520 - ALQUILER MAQUINARIA Y EQUIPO' },
  { value: '615525', label: '615525 - ALQUILER DE EFECTOS PERSONALES Y ENSERES DOMESTICOS' },
  { value: '615530', label: '615530 - CONSULTORIA EN EQUIPO Y PROGRAMAS DE INFORMATICA' },
  { value: '615535', label: '615535 - PROCESAMIENTO DE DATOS' },
  { value: '615540', label: '615540 - MANTENIMIENTO Y REPARACION DE MAQUINARIA DE OFICINA' },
  { value: '615545', label: '615545 - INVESTIGACIONES CIENTIFICAS Y DE DESARROLLO' },
  { value: '615550', label: '615550 - ACTIVIDADES EMPRESARIALES DE CONSULTORIA' },
  { value: '615555', label: '615555 - PUBLICIDAD' },
  { value: '615560', label: '615560 - DOTACION DE PERSONAL' },
  { value: '615565', label: '615565 - INVESTIGACION Y SEGURIDAD' },
  { value: '615570', label: '615570 - LIMPIEZA DE INMUEBLES' },
  { value: '615575', label: '615575 - FOTOGRAFIA' },
  { value: '615580', label: '615580 - ENVASE Y EMPAQUE' },
  { value: '615585', label: '615585 - FOTOCOPIADO' },
  { value: '615590', label: '615590 - MANTENIMIENTO Y REPARACION DE MAQUINARIA Y EQUIPO' },
  { value: '615595', label: '615595 - ACTIVIDADES CONEXAS' },
  { value: '615599', label: '615599 - AJUSTES POR INFLACION' },
  { value: '6160', label: '6160 - ENSEÑANZA' },
  { value: '616005', label: '616005 - ACTIVIDADES RELACIONADAS CON LA EDUCACION' },
  { value: '616099', label: '616099 - AJUSTES POR INFLACION' },
  { value: '6165', label: '6165 - SERVICIOS SOCIALES Y DE SALUD' },
  { value: '616505', label: '616505 - SERVICIO HOSPITALARIO' },
  { value: '616510', label: '616510 - SERVICIO MEDICO' },
  { value: '616515', label: '616515 - SERVICIO ODONTOLOGICO' },
  { value: '616520', label: '616520 - SERVICIO DE LABORATORIO' },
  { value: '616525', label: '616525 - ACTIVIDADES VETERINARIAS' },
  { value: '616530', label: '616530 - ACTIVIDADES DE SERVICIOS SOCIALES' },
  { value: '616595', label: '616595 - ACTIVIDADES CONEXAS' },
  { value: '616599', label: '616599 - AJUSTES POR INFLACION' },
  { value: '6170', label: '6170 - OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES Y PERSONALES' },
  { value: '617005', label: '617005 - ELIMINACION DE DESPERDICIOS Y AGUAS RESIDUALES' },
  { value: '617010', label: '617010 - ACTIVIDADES DE ASOCIACION' },
  { value: '617015', label: '617015 - PRODUCCION Y DISTRIBUCION DE FILMES Y VIDEOCINTAS' },
  { value: '617020', label: '617020 - EXHIBICION DE FILMES Y VIDEOCINTAS' },
  { value: '617025', label: '617025 - ACTIVIDAD DE RADIO Y TELEVISION' },
  { value: '617030', label: '617030 - ACTIVIDAD TEATRAL, MUSICAL Y ARTISTICA' },
  { value: '617035', label: '617035 - GRABACION Y PRODUCCION DE DISCOS' },
  { value: '617040', label: '617040 - ENTRETENIMIENTO Y ESPARCIMIENTO' },
  { value: '617045', label: '617045 - AGENCIAS DE NOTICIAS' },
  { value: '617050', label: '617050 - LAVANDERIAS Y SIMILARES' },
  { value: '617055', label: '617055 - PELUQUERIAS Y SIMILARES' },
  { value: '617060', label: '617060 - SERVICIOS FUNERARIOS' },
  { value: '617065', label: '617065 - ZONAS FRANCAS' },
  { value: '617095', label: '617095 - ACTIVIDADES CONEXAS' },
  { value: '617099', label: '617099 - AJUSTES POR INFLACION' },
  { value: '62', label: '62 - COMPRAS' },
  { value: '6205', label: '6205 - DE MERCANCIAS' },
  { value: '620599', label: '620599 - AJUSTES POR INFLACION' },
  { value: '6210', label: '6210 - DE MATERIAS PRIMAS' },
  { value: '621099', label: '621099 - AJUSTES POR INFLACION' },
  { value: '6215', label: '6215 - DE MATERIALES INDIRECTOS' },
  { value: '621599', label: '621599 - AJUSTES POR INFLACION' },
  { value: '6220', label: '6220 - COMPRA DE ENERGIA' },
  { value: '622001', label: '622001 - a 622098' },
  { value: '622099', label: '622099 - AJUSTES POR INFLACION' },
  { value: '6225', label: '6225 - DEVOLUCIONES REBAJAS Y DESCUENTOS EN COMPRAS (CR)' },
  { value: '622599', label: '622599 - AJUSTES POR INFLACION' },
  { value: '7', label: '7 - COSTOS DE PRODUCCION O DE OPERACION' },
  { value: '71', label: '71 - MATERIA PRIMA' },
  { value: '72', label: '72 - MANO DE OBRA DIRECTA' },
  { value: '73', label: '73 - COSTOS INDIRECTOS' },
  { value: '74', label: '74 - CONTRATOS DE SERVICIOS' },
  { value: '8', label: '8 - CUENTAS DE ORDEN DEUDORAS' },
  { value: '81', label: '81 - DERECHOS CONTINGENTES' },
  { value: '8105', label: '8105 - BIENES Y VALORES ENTREGADOS EN CUSTODIA' },
  { value: '810505', label: '810505 - VALORES MOBILIARIOS' },
  { value: '810510', label: '810510 - BIENES MUEBLES' },
  { value: '810599', label: '810599 - AJUSTES POR INFLACION' },
  { value: '8110', label: '8110 - BIENES Y VALORES ENTREGADOS EN GARANTIA' },
  { value: '811005', label: '811005 - VALORES MOBILIARIOS' },
  { value: '811010', label: '811010 - BIENES MUEBLES' },
  { value: '811015', label: '811015 - BIENES INMUEBLES' },
  { value: '811020', label: '811020 - CONTRATOS DE GANADO EN PARTICIPACION' },
  { value: '811099', label: '811099 - AJUSTES POR INFLACION' },
  { value: '8115', label: '8115 - BIENES Y VALORES EN PODER DE TERCEROS' },
  { value: '811505', label: '811505 - EN ARRENDAMIENTO' },
  { value: '811510', label: '811510 - EN PRESTAMO' },
  { value: '811515', label: '811515 - EN DEPOSITO' },
  { value: '811520', label: '811520 - EN CONSIGNACION' },
  { value: '811599', label: '811599 - AJUSTES POR INFLACION' },
  { value: '8120', label: '8120 - LITIGIOS Y/O DEMANDAS' },
  { value: '812005', label: '812005 - EJECUTIVOS' },
  { value: '812010', label: '812010 - INCUMPLIMIENTO DE CONTRATOS' },
  { value: '8125', label: '8125 - PROMESAS DE COMPRAVENTA' },
  { value: '8195', label: '8195 - DIVERSAS' },
  { value: '819505', label: '819505 - VALORES ADQUIRIDOS POR RECIBIR' },
  { value: '819595', label: '819595 - OTRAS' },
  { value: '819599', label: '819599 - AJUSTES POR INFLACION.' },
  { value: '82', label: '82 - DEUDORAS FISCALES' },
  { value: '83', label: '83 - DEUDORAS DE CONTROL' },
  { value: '8305', label: '8305 - BIENES RECIBIDOS EN ARRENDAMIENTO FINANCIERO' },
  { value: '830505', label: '830505 - BIENES MUEBLES' },
  { value: '830510', label: '830510 - BIENES INMUEBLES' },
  { value: '830599', label: '830599 - AJUSTES POR INFLACION' },
  { value: '8310', label: '8310 - TITULOS DE INVERSION NO COLOCADOS' },
  { value: '831005', label: '831005 - ACCIONES' },
  { value: '831010', label: '831010 - BONOS' },
  { value: '831095', label: '831095 - OTROS' },
  { value: '8315', label: '8315 - PROPIEDADES PLANTA Y EQUIPO TOTALMENTE DEPRECIADOS, AGOTADOS Y/O AMORTIZADOS' },
  { value: '831506', label: '831506 - MATERIALES PROYECTOS PETROLEROS' },
  { value: '831516', label: '831516 - CONSTRUCCIONES Y EDIFICACIONES' },
  { value: '831520', label: '831520 - MAQUINARIA Y EQUIPO' },
  { value: '831524', label: '831524 - EQUIPO DE OFICINA' },
  { value: '831528', label: '831528 - EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: '831532', label: '831532 - EQUIPO MEDICO - CIENTIFICO' },
  { value: '831536', label: '831536 - EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: '831540', label: '831540 - FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: '831544', label: '831544 - FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: '831548', label: '831548 - FLOTA Y EQUIPO AEREO' },
  { value: '831552', label: '831552 - FLOTA Y EQUIPO FERREO' },
  { value: '831556', label: '831556 - ACUEDUCTOS, PLANTAS Y REDES' },
  { value: '831560', label: '831560 - ARMAMENTO DE VIGILANCIA' },
  { value: '831562', label: '831562 - ENVASES Y EMPAQUES' },
  { value: '831564', label: '831564 - PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: '831568', label: '831568 - VIAS DE COMUNICACION' },
  { value: '831572', label: '831572 - MINAS Y CANTERAS' },
  { value: '831576', label: '831576 - POZOS ARTESIANOS' },
  { value: '831580', label: '831580 - YACIMIENTOS' },
  { value: '831584', label: '831584 - SEMOVIENTES' },
  { value: '831599', label: '831599 - AJUSTES POR INFLACION' },
  { value: '8320', label: '8320 - CREDITOS A FAVOR NO UTILIZADOS' },
  { value: '832005', label: '832005 - PAIS' },
  { value: '832010', label: '832010 - EXTERIOR' },
  { value: '8325', label: '8325 - ACTIVOS CASTIGADOS' },
  { value: '832505', label: '832505 - INVERSIONES' },
  { value: '832510', label: '832510 - DEUDORES' },
  { value: '832595', label: '832595 - OTROS ACTIVOS' },
  { value: '8330', label: '8330 - TITULOS DE INVERSION AMORTIZADOS' },
  { value: '833005', label: '833005 - BONOS' },
  { value: '833095', label: '833095 - OTROS' },
  { value: '8335', label: '8335 - CAPITALIZACION POR REVALORIZACION DE PATRIMONIO' },
  { value: '8395', label: '8395 - OTRAS CUENTAS DEUDORAS DE CONTROL' },
  { value: '839505', label: '839505 - CHEQUES POSTFECHADOS' },
  { value: '839510', label: '839510 - CERTIFICADOS DE DEPOSITO A TERMINO' },
  { value: '839515', label: '839515 - CHEQUES DEVUELTOS' },
  { value: '839520', label: '839520 - BIENES Y VALORES EN FIDEICOMISO' },
  { value: '839525', label: '839525 - INTERESES SOBRE DEUDAS VENCIDAS' },
  { value: '839595', label: '839595 - DIVERSAS' },
  { value: '839599', label: '839599 - AJUSTES POR INFLACION' },
  { value: '8399', label: '8399 - AJUSTES POR INFLACION ACTIVOS' },
  { value: '839905', label: '839905 - INVERSIONES' },
  { value: '839910', label: '839910 - INVENTARIOS' },
  { value: '839915', label: '839915 - PROPIEDADES PLANTA Y EQUIPO' },
  { value: '839920', label: '839920 - INTANGIBLES' },
  { value: '839925', label: '839925 - CARGOS DIFERIDOS' },
  { value: '839995', label: '839995 - OTROS ACTIVOS' },
  { value: '84', label: '84 - DERECHOS CONTINGENTES POR CONTRA (CR)' },
  { value: '85', label: '85 - DEUDORAS FISCALES POR CONTRA (CR)' },
  { value: '86', label: '86 - DEUDORAS DE CONTROL POR CONTRA (CR)' },
  { value: '9', label: '9 - CUENTAS DE ORDEN ACREEDORAS' },
  { value: '91', label: '91 - RESPONSABILIDADES CONTINGENTES' },
  { value: '9105', label: '9105 - BIENES Y VALORES RECIBIDOS EN CUSTODIA' },
  { value: '910505', label: '910505 - VALORES MOBILIARIOS' },
  { value: '910510', label: '910510 - BIENES MUEBLES' },
  { value: '910599', label: '910599 - AJUSTES POR INFLACION' },
  { value: '9110', label: '9110 - BIENES Y VALORES RECIBIDOS EN GARANTIA' },
  { value: '911005', label: '911005 - VALORES MOBILIARIOS' },
  { value: '911010', label: '911010 - BIENES MUEBLES' },
  { value: '911015', label: '911015 - BIENES INMUEBLES' },
  { value: '911020', label: '911020 - CONTRATOS DE GANADO EN PARTICIPACION' },
  { value: '911099', label: '911099 - AJUSTES POR INFLACION' },
  { value: '9115', label: '9115 - BIENES Y VALORES RECIBIDOS DE TERCEROS' },
  { value: '911505', label: '911505 - EN ARRENDAMIENTO' },
  { value: '911510', label: '911510 - EN PRESTAMO' },
  { value: '911515', label: '911515 - EN DEPOSITO' },
  { value: '911520', label: '911520 - EN CONSIGNACION' },
  { value: '911525', label: '911525 - EN COMODATO' },
  { value: '911599', label: '911599 - AJUSTES POR INFLACION' },
  { value: '9120', label: '9120 - LITIGIOS Y/O DEMANDAS' },
  { value: '912005', label: '912005 - LABORALES' },
  { value: '912010', label: '912010 - CIVILES' },
  { value: '912015', label: '912015 - ADMINISTRATIVOS O ARBITRALES' },
  { value: '912020', label: '912020 - TRIBUTARIOS' },
  { value: '9125', label: '9125 - PROMESAS DE COMPRAVENTA' },
  { value: '9130', label: '9130 - CONTRATOS DE ADMINISTRACION DELEGADA' },
  { value: '9135', label: '9135 - CUENTAS EN PARTICIPACION' },
  { value: '9195', label: '9195 - OTRAS RESPONSABILIDADES CONTINGENTES' },
  { value: '92', label: '92 - ACREEDORAS FISCALES' },
  { value: '93', label: '93 - ACREEDORAS DE CONTROL' },
  { value: '9305', label: '9305 - CONTRATOS DE ARRENDAMIENTO FINANCIERO' },
  { value: '930505', label: '930505 - BIENES MUEBLES' },
  { value: '930510', label: '930510 - BIENES INMUEBLES' },
  { value: '9395', label: '9395 - OTRAS CUENTAS DE ORDEN ACREEDORAS DE CONTROL' },
  { value: '939505', label: '939505 - DOCUMENTOS POR COBRAR DESCONTADOS' },
  { value: '939510', label: '939510 - CONVENIOS DE PAGO' },
  { value: '939515', label: '939515 - CONTRATOS DE CONSTRUCCIONES E INSTALACIONES POR EJECUTAR' },
  { value: '939520', label: '939520 - PEDIDOS COLOCADOS' },
  { value: '939525', label: '939525 - ADJUDICACIONES PENDIENTES DE LEGALIZAR' },
  { value: '939530', label: '939530 - RESERVA ARTICULO 3o. LEY 4/80' },
  { value: '939535', label: '939535 - RESERVA COSTO REPOSICION SEMOVIENTES' },
  { value: '939599', label: '939599 - AJUSTES POR INFLACION' },
  { value: '9399', label: '9399 - AJUSTES POR INFLACION PATRIMONIO' },
  { value: '939905', label: '939905 - CAPITAL SOCIAL' },
  { value: '939910', label: '939910 - SUPERAVIT DE CAPITAL' },
  { value: '939915', label: '939915 - RESERVAS' },
  { value: '939925', label: '939925 - DIVIDENDOS O PARTICIPACIONES DECRETADAS EN ACCIONES, CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: '939930', label: '939930 - RESULTADOS DE EJERCICIOS ANTERIORES' },
  { value: '94', label: '94 - RESPONSABILIDADES CONTINGENTES POR CONTRA (DB)' },
  { value: '95', label: '95 - ACREEDORAS FISCALES POR CONTRA (DB)' },
  { value: '96', label: '96 - ACREEDORAS DE CONTROL POR CONTRA (DB)' }
];
